/* eslint-disable */
// biome-ignore-all lint: auto-generated
//
// This file is auto-generated by autoexport.
// Do not modify manually, please do: vp run check.
//
// plugin: WasmMinimap

export const enum DefaultMinimap {
  fd_close = "1",
  fd_write = "2",
  fd_read = "3",
  fd_seek = "4",
  environ_get = "5",
  environ_sizes_get = "6",
  proc_exit = "7",
  fd_pread = "8",
  fd_pwrite = "9",
  clock_time_get = "a",
  _tzset_js = "b",
  _localtime_js = "c",
  _gmtime_js = "d",
  __syscall_fcntl64 = "e",
  __syscall_ioctl = "f",
  __syscall_openat = "g",
  __syscall_stat64 = "h",
  __syscall_unlinkat = "i",
  __syscall_rmdir = "j",
  __syscall_getdents64 = "k",
  _emscripten_runtime_keepalive_clear = "l",
  _setitimer_js = "m",
  _mmap_js = "n",
  _munmap_js = "o",
  emscripten_resize_heap = "p",
  emscripten_date_now = "q",
  _abort_js = "r",
  _emscripten_throw_longjmp = "s",
  __syscall_getcwd = "t",
  __assert_fail = "u",
  __syscall_dup = "v",
  __syscall_dup3 = "w",
  __syscall_fstat64 = "x",
  __syscall_lstat64 = "y",
  __syscall_newfstatat = "z",
  __syscall_renameat = "10",
  __cxa_throw = "11",
  exit = "12",
  log_str = "13",
  env = "14",
  wasi_snapshot_preview1 = "15",
  memory = "16",
  __indirect_function_table = "17",
  __wasm_call_ctors = "18",
  setThrew = "19",
  emscripten_stack_get_current = "1a",
  _emscripten_stack_restore = "1b",
  invoke_ii = "1c",
  invoke_iii = "1d",
  invoke_iiii = "1e",
  invoke_iiiii = "1f",
  invoke_iiiiii = "1g",
  invoke_iiiiiii = "1h",
  invoke_iiiiiiii = "1i",
  invoke_iiiiiiiii = "1j",
  invoke_iiiiiiiiii = "1k",
  invoke_iiiiiiiiiiii = "1l",
  invoke_v = "1m",
  invoke_vi = "1n",
  invoke_vii = "1o",
  invoke_viii = "1p",
  invoke_viiii = "1q",
  invoke_viiiii = "1r",
  invoke_viiiiii = "1s",
  invoke_viiiiiii = "1t",
  invoke_viiiiiiii = "1u",
  invoke_viiiiiiiii = "1v",
  invoke_iiji = "1w",
  invoke_iji = "1x",
  invoke_jji = "1y",
  invoke_jiji = "1z",
  invoke_iij = "20",
  invoke_jii = "21",
  invoke_ji = "22",
  invoke_diiid = "23",
  invoke_iidi = "24",
  invoke_iddii = "25",
  invoke_iiiiiij = "26",
  invoke_iiiiiiiiiijj = "27",
  invoke_iiiiiiiiiiji = "28",
  invoke_iiiiiiijjii = "29",
  invoke_iijiii = "2a",
  invoke_iiijiii = "2b",
  invoke_iiiijj = "2c",
  invoke_iidiii = "2d",
  invoke_fdi = "2e",
  invoke_idii = "2f",
  invoke_iiiiiiiifi = "2g",
  invoke_vijii = "2h",
  invoke_iiiijii = "2i",
  invoke_iiiiijiiiii = "2j",
  invoke_fdii = "2k",
  invoke_viiiiiiiiijiiii = "2l",
  invoke_id = "2m",
  invoke_dd = "2n",
  invoke_viij = "2o",
  invoke_fdd = "2p",
  invoke_iiiij = "2q",
  invoke_iiiiijiiii = "2r",
  invoke_iiijii = "2s",
  invoke_iiiijiiii = "2t",
  invoke_iiiji = "2u",
  invoke_iidiiii = "2v",
  invoke_iijii = "2w",
  invoke_iijj = "2x",
  invoke_iijjjjjj = "2y",
  invoke_viiiiiiiiiiiiiijiiiii = "2z",
  invoke_viiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiijiiiiii = "30",
  invoke_iiiiiiiiiiiiiiiii = "31",
  invoke_iiiiiiiiiiiiii = "32",
  invoke_iiiiiiiiiiiii = "33",
  invoke_iiiiiiiiiiiiiiii = "34",
  invoke_iiiiiiiiiii = "35",
  invoke_iiiiiiiiiiiiiii = "36",
  invoke_djijd = "37",
  invoke_fdj = "38",
  invoke_fdjj = "39",
  invoke_iddjj = "3a",
  invoke_idjj = "3b",
  invoke_iidjjj = "3c",
  invoke_iijjj = "3d",
  invoke_ij = "3e",
  invoke_ijdj = "3f",
  invoke_ijii = "3g",
  invoke_ijiii = "3h",
  invoke_ijiiii = "3i",
  invoke_ijiiiiiii = "3j",
  invoke_ijiiiiiiji = "3k",
  invoke_ijiiiij = "3l",
  invoke_ijiiiijiii = "3m",
  invoke_ijiiiijij = "3n",
  invoke_ijiiij = "3o",
  invoke_ijiiijjiiiiii = "3p",
  invoke_ijiij = "3q",
  invoke_ijiiji = "3r",
  invoke_ijiijj = "3s",
  invoke_ijij = "3t",
  invoke_ijiji = "3u",
  invoke_ijijijj = "3v",
  invoke_ijijj = "3w",
  invoke_ijijjj = "3x",
  invoke_ijijjjj = "3y",
  invoke_ijj = "3z",
  invoke_ijji = "40",
  invoke_ijjii = "41",
  invoke_ijjiiiij = "42",
  invoke_ijjiiiijjii = "43",
  invoke_ijjiiij = "44",
  invoke_ijjiiijjji = "45",
  invoke_ijjiij = "46",
  invoke_ijjiijiiii = "47",
  invoke_ijjiijiiiii = "48",
  invoke_ijjiijiiiiji = "49",
  invoke_ijjiijiiiijii = "4a",
  invoke_ijjiijiiiijiij = "4b",
  invoke_ijjiijiiiijj = "4c",
  invoke_ijjiijjjjiiiiiiii = "4d",
  invoke_ijjiijjjjjjjiiii = "4e",
  invoke_ijjij = "4f",
  invoke_ijjiji = "4g",
  invoke_ijjijiii = "4h",
  invoke_ijjijj = "4i",
  invoke_ijjijjj = "4j",
  invoke_ijjj = "4k",
  invoke_ijjji = "4l",
  invoke_ijjjii = "4m",
  invoke_ijjjiiiiiiii = "4n",
  invoke_ijjjiiiji = "4o",
  invoke_ijjjiiijj = "4p",
  invoke_ijjjij = "4q",
  invoke_ijjjijj = "4r",
  invoke_ijjjijji = "4s",
  invoke_ijjjj = "4t",
  invoke_ijjjji = "4u",
  invoke_ijjjjii = "4v",
  invoke_ijjjjj = "4w",
  invoke_ijjjjji = "4x",
  invoke_ijjjjjij = "4y",
  invoke_ijjjjjj = "4z",
  invoke_ijjjjjji = "50",
  invoke_ijjjjjjiij = "51",
  invoke_ijjjjjjijii = "52",
  invoke_ijjjjjjj = "53",
  invoke_ijjjjjjjfj = "54",
  invoke_ijjjjjjjj = "55",
  invoke_ijjjjjjjji = "56",
  invoke_ijjjjjjjjj = "57",
  invoke_ijjjjjjjjjj = "58",
  invoke_ijjjjjjjjjjj = "59",
  invoke_ijjjjjjjjjjjjj = "5a",
  invoke_ijjjjjjjjjjjjjj = "5b",
  invoke_jj = "5c",
  invoke_jjii = "5d",
  invoke_jjiii = "5e",
  invoke_jjiiiii = "5f",
  invoke_jjiijj = "5g",
  invoke_jjij = "5h",
  invoke_jjijjjji = "5i",
  invoke_jjj = "5j",
  invoke_jjji = "5k",
  invoke_jjjiii = "5l",
  invoke_jjjiijjj = "5m",
  invoke_jjjj = "5n",
  invoke_jjjji = "5o",
  invoke_jjjjiijii = "5p",
  invoke_jjjjj = "5q",
  invoke_jjjjji = "5r",
  invoke_jjjjjj = "5s",
  invoke_viiiiiijji = "5t",
  invoke_viiiijjjij = "5u",
  invoke_viiijjji = "5v",
  invoke_viijj = "5w",
  invoke_viijjiiiiiiijiijiiiii = "5x",
  invoke_vijjj = "5y",
  invoke_vijjji = "5z",
  invoke_vijjjij = "60",
  invoke_vj = "61",
  invoke_vji = "62",
  invoke_vjii = "63",
  invoke_vjiiii = "64",
  invoke_vjiiiiiiiiiiijjiiijiiijijijjiiiiijiiiijj = "65",
  invoke_vjiiiiiiiijjjjj = "66",
  invoke_vjiiiij = "67",
  invoke_vjiij = "68",
  invoke_vjiijiii = "69",
  invoke_vjiijj = "6a",
  invoke_vjij = "6b",
  invoke_vjijj = "6c",
  invoke_vjijjjj = "6d",
  invoke_vjj = "6e",
  invoke_vjji = "6f",
  invoke_vjjii = "6g",
  invoke_vjjiii = "6h",
  invoke_vjjiiiijj = "6i",
  invoke_vjjiiij = "6j",
  invoke_vjjiiijj = "6k",
  invoke_vjjij = "6l",
  invoke_vjjiji = "6m",
  invoke_vjjijj = "6n",
  invoke_vjjj = "6o",
  invoke_vjjji = "6p",
  invoke_vjjjii = "6q",
  invoke_vjjjiii = "6r",
  invoke_vjjjijji = "6s",
  invoke_vjjjj = "6t",
  invoke_vjjjji = "6u",
  invoke_vjjjjii = "6v",
  invoke_vjjjjiij = "6w",
  invoke_vjjjjiijj = "6x",
  invoke_vjjjjij = "6y",
  invoke_vjjjjj = "6z",
  dynCall_ii = "70",
  dynCall_iii = "71",
  dynCall_iiii = "72",
  dynCall_iiiii = "73",
  dynCall_iiiiii = "74",
  dynCall_iiiiiii = "75",
  dynCall_iiiiiiii = "76",
  dynCall_iiiiiiiii = "77",
  dynCall_iiiiiiiiii = "78",
  dynCall_iiiiiiiiiiii = "79",
  dynCall_v = "7a",
  dynCall_vi = "7b",
  dynCall_vii = "7c",
  dynCall_viii = "7d",
  dynCall_viiii = "7e",
  dynCall_viiiii = "7f",
  dynCall_viiiiii = "7g",
  dynCall_viiiiiii = "7h",
  dynCall_viiiiiiii = "7i",
  dynCall_viiiiiiiii = "7j",
  dynCall_iiji = "7k",
  dynCall_iji = "7l",
  dynCall_jji = "7m",
  dynCall_jiji = "7n",
  dynCall_iij = "7o",
  dynCall_jii = "7p",
  dynCall_ji = "7q",
  dynCall_diiid = "7r",
  dynCall_iidi = "7s",
  dynCall_iddii = "7t",
  dynCall_iiiiiij = "7u",
  dynCall_iiiiiiiiiijj = "7v",
  dynCall_iiiiiiiiiiji = "7w",
  dynCall_iiiiiiijjii = "7x",
  dynCall_iijiii = "7y",
  dynCall_iiijiii = "7z",
  dynCall_iiiijj = "80",
  dynCall_iidiii = "81",
  dynCall_fdi = "82",
  dynCall_idii = "83",
  dynCall_iiiiiiiifi = "84",
  dynCall_vijii = "85",
  dynCall_iiiijii = "86",
  dynCall_iiiiijiiiii = "87",
  dynCall_fdii = "88",
  dynCall_viiiiiiiiijiiii = "89",
  dynCall_id = "8a",
  dynCall_dd = "8b",
  dynCall_viij = "8c",
  dynCall_fdd = "8d",
  dynCall_iiiij = "8e",
  dynCall_iiiiijiiii = "8f",
  dynCall_iiijii = "8g",
  dynCall_iiiijiiii = "8h",
  dynCall_iiiji = "8i",
  dynCall_iidiiii = "8j",
  dynCall_iijii = "8k",
  dynCall_iijj = "8l",
  dynCall_iijjjjjj = "8m",
  dynCall_viiiiiiiiiiiiiijiiiii = "8n",
  dynCall_viiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiijiiiiii = "8o",
  dynCall_iiiiiiiiiiiiiiiii = "8p",
  dynCall_iiiiiiiiiiiiii = "8q",
  dynCall_iiiiiiiiiiiii = "8r",
  dynCall_iiiiiiiiiiiiiiii = "8s",
  dynCall_iiiiiiiiiii = "8t",
  dynCall_iiiiiiiiiiiiiii = "8u",
  dynCall_djijd = "8v",
  dynCall_fdj = "8w",
  dynCall_fdjj = "8x",
  dynCall_iddjj = "8y",
  dynCall_idjj = "8z",
  dynCall_iidjjj = "90",
  dynCall_iijjj = "91",
  dynCall_ij = "92",
  dynCall_ijdj = "93",
  dynCall_ijii = "94",
  dynCall_ijiii = "95",
  dynCall_ijiiii = "96",
  dynCall_ijiiiiiii = "97",
  dynCall_ijiiiiiiji = "98",
  dynCall_ijiiiij = "99",
  dynCall_ijiiiijiii = "9a",
  dynCall_ijiiiijij = "9b",
  dynCall_ijiiij = "9c",
  dynCall_ijiiijjiiiiii = "9d",
  dynCall_ijiij = "9e",
  dynCall_ijiiji = "9f",
  dynCall_ijiijj = "9g",
  dynCall_ijij = "9h",
  dynCall_ijiji = "9i",
  dynCall_ijijijj = "9j",
  dynCall_ijijj = "9k",
  dynCall_ijijjj = "9l",
  dynCall_ijijjjj = "9m",
  dynCall_ijj = "9n",
  dynCall_ijji = "9o",
  dynCall_ijjii = "9p",
  dynCall_ijjiiiij = "9q",
  dynCall_ijjiiiijjii = "9r",
  dynCall_ijjiiij = "9s",
  dynCall_ijjiiijjji = "9t",
  dynCall_ijjiij = "9u",
  dynCall_ijjiijiiii = "9v",
  dynCall_ijjiijiiiii = "9w",
  dynCall_ijjiijiiiiji = "9x",
  dynCall_ijjiijiiiijii = "9y",
  dynCall_ijjiijiiiijiij = "9z",
  dynCall_ijjiijiiiijj = "a0",
  dynCall_ijjiijjjjiiiiiiii = "a1",
  dynCall_ijjiijjjjjjjiiii = "a2",
  dynCall_ijjij = "a3",
  dynCall_ijjiji = "a4",
  dynCall_ijjijiii = "a5",
  dynCall_ijjijj = "a6",
  dynCall_ijjijjj = "a7",
  dynCall_ijjj = "a8",
  dynCall_ijjji = "a9",
  dynCall_ijjjii = "aa",
  dynCall_ijjjiiiiiiii = "ab",
  dynCall_ijjjiiiji = "ac",
  dynCall_ijjjiiijj = "ad",
  dynCall_ijjjij = "ae",
  dynCall_ijjjijj = "af",
  dynCall_ijjjijji = "ag",
  dynCall_ijjjj = "ah",
  dynCall_ijjjji = "ai",
  dynCall_ijjjjii = "aj",
  dynCall_ijjjjj = "ak",
  dynCall_ijjjjji = "al",
  dynCall_ijjjjjij = "am",
  dynCall_ijjjjjj = "an",
  dynCall_ijjjjjji = "ao",
  dynCall_ijjjjjjiij = "ap",
  dynCall_ijjjjjjijii = "aq",
  dynCall_ijjjjjjj = "ar",
  dynCall_ijjjjjjjfj = "as",
  dynCall_ijjjjjjjj = "at",
  dynCall_ijjjjjjjji = "au",
  dynCall_ijjjjjjjjj = "av",
  dynCall_ijjjjjjjjjj = "aw",
  dynCall_ijjjjjjjjjjj = "ax",
  dynCall_ijjjjjjjjjjjjj = "ay",
  dynCall_ijjjjjjjjjjjjjj = "az",
  dynCall_jj = "b0",
  dynCall_jjii = "b1",
  dynCall_jjiii = "b2",
  dynCall_jjiiiii = "b3",
  dynCall_jjiijj = "b4",
  dynCall_jjij = "b5",
  dynCall_jjijjjji = "b6",
  dynCall_jjj = "b7",
  dynCall_jjji = "b8",
  dynCall_jjjiii = "b9",
  dynCall_jjjiijjj = "ba",
  dynCall_jjjj = "bb",
  dynCall_jjjji = "bc",
  dynCall_jjjjiijii = "bd",
  dynCall_jjjjj = "be",
  dynCall_jjjjji = "bf",
  dynCall_jjjjjj = "bg",
  dynCall_viiiiiijji = "bh",
  dynCall_viiiijjjij = "bi",
  dynCall_viiijjji = "bj",
  dynCall_viijj = "bk",
  dynCall_viijjiiiiiiijiijiiiii = "bl",
  dynCall_vijjj = "bm",
  dynCall_vijjji = "bn",
  dynCall_vijjjij = "bo",
  dynCall_vj = "bp",
  dynCall_vji = "bq",
  dynCall_vjii = "br",
  dynCall_vjiiii = "bs",
  dynCall_vjiiiiiiiiiiijjiiijiiijijijjiiiiijiiiijj = "bt",
  dynCall_vjiiiiiiiijjjjj = "bu",
  dynCall_vjiiiij = "bv",
  dynCall_vjiij = "bw",
  dynCall_vjiijiii = "bx",
  dynCall_vjiijj = "by",
  dynCall_vjij = "bz",
  dynCall_vjijj = "c0",
  dynCall_vjijjjj = "c1",
  dynCall_vjj = "c2",
  dynCall_vjji = "c3",
  dynCall_vjjii = "c4",
  dynCall_vjjiii = "c5",
  dynCall_vjjiiiijj = "c6",
  dynCall_vjjiiij = "c7",
  dynCall_vjjiiijj = "c8",
  dynCall_vjjij = "c9",
  dynCall_vjjiji = "ca",
  dynCall_vjjijj = "cb",
  dynCall_vjjj = "cc",
  dynCall_vjjji = "cd",
  dynCall_vjjjii = "ce",
  dynCall_vjjjiii = "cf",
  dynCall_vjjjijji = "cg",
  dynCall_vjjjj = "ch",
  dynCall_vjjjji = "ci",
  dynCall_vjjjjii = "cj",
  dynCall_vjjjjiij = "ck",
  dynCall_vjjjjiijj = "cl",
  dynCall_vjjjjij = "cm",
  dynCall_vjjjjj = "cn",
  malloc = "$1",
  free = "$2",
}

export const RenameMap = {
  fd_close: DefaultMinimap.fd_close,
  fd_write: DefaultMinimap.fd_write,
  fd_read: DefaultMinimap.fd_read,
  fd_seek: DefaultMinimap.fd_seek,
  environ_get: DefaultMinimap.environ_get,
  environ_sizes_get: DefaultMinimap.environ_sizes_get,
  proc_exit: DefaultMinimap.proc_exit,
  fd_pread: DefaultMinimap.fd_pread,
  fd_pwrite: DefaultMinimap.fd_pwrite,
  clock_time_get: DefaultMinimap.clock_time_get,
  _tzset_js: DefaultMinimap._tzset_js,
  _localtime_js: DefaultMinimap._localtime_js,
  _gmtime_js: DefaultMinimap._gmtime_js,
  __syscall_fcntl64: DefaultMinimap.__syscall_fcntl64,
  __syscall_ioctl: DefaultMinimap.__syscall_ioctl,
  __syscall_openat: DefaultMinimap.__syscall_openat,
  __syscall_stat64: DefaultMinimap.__syscall_stat64,
  __syscall_unlinkat: DefaultMinimap.__syscall_unlinkat,
  __syscall_rmdir: DefaultMinimap.__syscall_rmdir,
  __syscall_getdents64: DefaultMinimap.__syscall_getdents64,
  _emscripten_runtime_keepalive_clear: DefaultMinimap._emscripten_runtime_keepalive_clear,
  _setitimer_js: DefaultMinimap._setitimer_js,
  _mmap_js: DefaultMinimap._mmap_js,
  _munmap_js: DefaultMinimap._munmap_js,
  emscripten_resize_heap: DefaultMinimap.emscripten_resize_heap,
  emscripten_date_now: DefaultMinimap.emscripten_date_now,
  _abort_js: DefaultMinimap._abort_js,
  _emscripten_throw_longjmp: DefaultMinimap._emscripten_throw_longjmp,
  __syscall_getcwd: DefaultMinimap.__syscall_getcwd,
  __assert_fail: DefaultMinimap.__assert_fail,
  __syscall_dup: DefaultMinimap.__syscall_dup,
  __syscall_dup3: DefaultMinimap.__syscall_dup3,
  __syscall_fstat64: DefaultMinimap.__syscall_fstat64,
  __syscall_lstat64: DefaultMinimap.__syscall_lstat64,
  __syscall_newfstatat: DefaultMinimap.__syscall_newfstatat,
  __syscall_renameat: DefaultMinimap.__syscall_renameat,
  __cxa_throw: DefaultMinimap.__cxa_throw,
  exit: DefaultMinimap.exit,
  log_str: DefaultMinimap.log_str,
  env: DefaultMinimap.env,
  wasi_snapshot_preview1: DefaultMinimap.wasi_snapshot_preview1,
  memory: DefaultMinimap.memory,
  __indirect_function_table: DefaultMinimap.__indirect_function_table,
  __wasm_call_ctors: DefaultMinimap.__wasm_call_ctors,
  setThrew: DefaultMinimap.setThrew,
  emscripten_stack_get_current: DefaultMinimap.emscripten_stack_get_current,
  _emscripten_stack_restore: DefaultMinimap._emscripten_stack_restore,
  invoke_ii: DefaultMinimap.invoke_ii,
  invoke_iii: DefaultMinimap.invoke_iii,
  invoke_iiii: DefaultMinimap.invoke_iiii,
  invoke_iiiii: DefaultMinimap.invoke_iiiii,
  invoke_iiiiii: DefaultMinimap.invoke_iiiiii,
  invoke_iiiiiii: DefaultMinimap.invoke_iiiiiii,
  invoke_iiiiiiii: DefaultMinimap.invoke_iiiiiiii,
  invoke_iiiiiiiii: DefaultMinimap.invoke_iiiiiiiii,
  invoke_iiiiiiiiii: DefaultMinimap.invoke_iiiiiiiiii,
  invoke_iiiiiiiiiiii: DefaultMinimap.invoke_iiiiiiiiiiii,
  invoke_v: DefaultMinimap.invoke_v,
  invoke_vi: DefaultMinimap.invoke_vi,
  invoke_vii: DefaultMinimap.invoke_vii,
  invoke_viii: DefaultMinimap.invoke_viii,
  invoke_viiii: DefaultMinimap.invoke_viiii,
  invoke_viiiii: DefaultMinimap.invoke_viiiii,
  invoke_viiiiii: DefaultMinimap.invoke_viiiiii,
  invoke_viiiiiii: DefaultMinimap.invoke_viiiiiii,
  invoke_viiiiiiii: DefaultMinimap.invoke_viiiiiiii,
  invoke_viiiiiiiii: DefaultMinimap.invoke_viiiiiiiii,
  invoke_iiji: DefaultMinimap.invoke_iiji,
  invoke_iji: DefaultMinimap.invoke_iji,
  invoke_jji: DefaultMinimap.invoke_jji,
  invoke_jiji: DefaultMinimap.invoke_jiji,
  invoke_iij: DefaultMinimap.invoke_iij,
  invoke_jii: DefaultMinimap.invoke_jii,
  invoke_ji: DefaultMinimap.invoke_ji,
  invoke_diiid: DefaultMinimap.invoke_diiid,
  invoke_iidi: DefaultMinimap.invoke_iidi,
  invoke_iddii: DefaultMinimap.invoke_iddii,
  invoke_iiiiiij: DefaultMinimap.invoke_iiiiiij,
  invoke_iiiiiiiiiijj: DefaultMinimap.invoke_iiiiiiiiiijj,
  invoke_iiiiiiiiiiji: DefaultMinimap.invoke_iiiiiiiiiiji,
  invoke_iiiiiiijjii: DefaultMinimap.invoke_iiiiiiijjii,
  invoke_iijiii: DefaultMinimap.invoke_iijiii,
  invoke_iiijiii: DefaultMinimap.invoke_iiijiii,
  invoke_iiiijj: DefaultMinimap.invoke_iiiijj,
  invoke_iidiii: DefaultMinimap.invoke_iidiii,
  invoke_fdi: DefaultMinimap.invoke_fdi,
  invoke_idii: DefaultMinimap.invoke_idii,
  invoke_iiiiiiiifi: DefaultMinimap.invoke_iiiiiiiifi,
  invoke_vijii: DefaultMinimap.invoke_vijii,
  invoke_iiiijii: DefaultMinimap.invoke_iiiijii,
  invoke_iiiiijiiiii: DefaultMinimap.invoke_iiiiijiiiii,
  invoke_fdii: DefaultMinimap.invoke_fdii,
  invoke_viiiiiiiiijiiii: DefaultMinimap.invoke_viiiiiiiiijiiii,
  invoke_id: DefaultMinimap.invoke_id,
  invoke_dd: DefaultMinimap.invoke_dd,
  invoke_viij: DefaultMinimap.invoke_viij,
  invoke_fdd: DefaultMinimap.invoke_fdd,
  invoke_iiiij: DefaultMinimap.invoke_iiiij,
  invoke_iiiiijiiii: DefaultMinimap.invoke_iiiiijiiii,
  invoke_iiijii: DefaultMinimap.invoke_iiijii,
  invoke_iiiijiiii: DefaultMinimap.invoke_iiiijiiii,
  invoke_iiiji: DefaultMinimap.invoke_iiiji,
  invoke_iidiiii: DefaultMinimap.invoke_iidiiii,
  invoke_iijii: DefaultMinimap.invoke_iijii,
  invoke_iijj: DefaultMinimap.invoke_iijj,
  invoke_iijjjjjj: DefaultMinimap.invoke_iijjjjjj,
  invoke_viiiiiiiiiiiiiijiiiii: DefaultMinimap.invoke_viiiiiiiiiiiiiijiiiii,
  invoke_viiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiijiiiiii: DefaultMinimap.invoke_viiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiijiiiiii,
  invoke_iiiiiiiiiiiiiiiii: DefaultMinimap.invoke_iiiiiiiiiiiiiiiii,
  invoke_iiiiiiiiiiiiii: DefaultMinimap.invoke_iiiiiiiiiiiiii,
  invoke_iiiiiiiiiiiii: DefaultMinimap.invoke_iiiiiiiiiiiii,
  invoke_iiiiiiiiiiiiiiii: DefaultMinimap.invoke_iiiiiiiiiiiiiiii,
  invoke_iiiiiiiiiii: DefaultMinimap.invoke_iiiiiiiiiii,
  invoke_iiiiiiiiiiiiiii: DefaultMinimap.invoke_iiiiiiiiiiiiiii,
  invoke_djijd: DefaultMinimap.invoke_djijd,
  invoke_fdj: DefaultMinimap.invoke_fdj,
  invoke_fdjj: DefaultMinimap.invoke_fdjj,
  invoke_iddjj: DefaultMinimap.invoke_iddjj,
  invoke_idjj: DefaultMinimap.invoke_idjj,
  invoke_iidjjj: DefaultMinimap.invoke_iidjjj,
  invoke_iijjj: DefaultMinimap.invoke_iijjj,
  invoke_ij: DefaultMinimap.invoke_ij,
  invoke_ijdj: DefaultMinimap.invoke_ijdj,
  invoke_ijii: DefaultMinimap.invoke_ijii,
  invoke_ijiii: DefaultMinimap.invoke_ijiii,
  invoke_ijiiii: DefaultMinimap.invoke_ijiiii,
  invoke_ijiiiiiii: DefaultMinimap.invoke_ijiiiiiii,
  invoke_ijiiiiiiji: DefaultMinimap.invoke_ijiiiiiiji,
  invoke_ijiiiij: DefaultMinimap.invoke_ijiiiij,
  invoke_ijiiiijiii: DefaultMinimap.invoke_ijiiiijiii,
  invoke_ijiiiijij: DefaultMinimap.invoke_ijiiiijij,
  invoke_ijiiij: DefaultMinimap.invoke_ijiiij,
  invoke_ijiiijjiiiiii: DefaultMinimap.invoke_ijiiijjiiiiii,
  invoke_ijiij: DefaultMinimap.invoke_ijiij,
  invoke_ijiiji: DefaultMinimap.invoke_ijiiji,
  invoke_ijiijj: DefaultMinimap.invoke_ijiijj,
  invoke_ijij: DefaultMinimap.invoke_ijij,
  invoke_ijiji: DefaultMinimap.invoke_ijiji,
  invoke_ijijijj: DefaultMinimap.invoke_ijijijj,
  invoke_ijijj: DefaultMinimap.invoke_ijijj,
  invoke_ijijjj: DefaultMinimap.invoke_ijijjj,
  invoke_ijijjjj: DefaultMinimap.invoke_ijijjjj,
  invoke_ijj: DefaultMinimap.invoke_ijj,
  invoke_ijji: DefaultMinimap.invoke_ijji,
  invoke_ijjii: DefaultMinimap.invoke_ijjii,
  invoke_ijjiiiij: DefaultMinimap.invoke_ijjiiiij,
  invoke_ijjiiiijjii: DefaultMinimap.invoke_ijjiiiijjii,
  invoke_ijjiiij: DefaultMinimap.invoke_ijjiiij,
  invoke_ijjiiijjji: DefaultMinimap.invoke_ijjiiijjji,
  invoke_ijjiij: DefaultMinimap.invoke_ijjiij,
  invoke_ijjiijiiii: DefaultMinimap.invoke_ijjiijiiii,
  invoke_ijjiijiiiii: DefaultMinimap.invoke_ijjiijiiiii,
  invoke_ijjiijiiiiji: DefaultMinimap.invoke_ijjiijiiiiji,
  invoke_ijjiijiiiijii: DefaultMinimap.invoke_ijjiijiiiijii,
  invoke_ijjiijiiiijiij: DefaultMinimap.invoke_ijjiijiiiijiij,
  invoke_ijjiijiiiijj: DefaultMinimap.invoke_ijjiijiiiijj,
  invoke_ijjiijjjjiiiiiiii: DefaultMinimap.invoke_ijjiijjjjiiiiiiii,
  invoke_ijjiijjjjjjjiiii: DefaultMinimap.invoke_ijjiijjjjjjjiiii,
  invoke_ijjij: DefaultMinimap.invoke_ijjij,
  invoke_ijjiji: DefaultMinimap.invoke_ijjiji,
  invoke_ijjijiii: DefaultMinimap.invoke_ijjijiii,
  invoke_ijjijj: DefaultMinimap.invoke_ijjijj,
  invoke_ijjijjj: DefaultMinimap.invoke_ijjijjj,
  invoke_ijjj: DefaultMinimap.invoke_ijjj,
  invoke_ijjji: DefaultMinimap.invoke_ijjji,
  invoke_ijjjii: DefaultMinimap.invoke_ijjjii,
  invoke_ijjjiiiiiiii: DefaultMinimap.invoke_ijjjiiiiiiii,
  invoke_ijjjiiiji: DefaultMinimap.invoke_ijjjiiiji,
  invoke_ijjjiiijj: DefaultMinimap.invoke_ijjjiiijj,
  invoke_ijjjij: DefaultMinimap.invoke_ijjjij,
  invoke_ijjjijj: DefaultMinimap.invoke_ijjjijj,
  invoke_ijjjijji: DefaultMinimap.invoke_ijjjijji,
  invoke_ijjjj: DefaultMinimap.invoke_ijjjj,
  invoke_ijjjji: DefaultMinimap.invoke_ijjjji,
  invoke_ijjjjii: DefaultMinimap.invoke_ijjjjii,
  invoke_ijjjjj: DefaultMinimap.invoke_ijjjjj,
  invoke_ijjjjji: DefaultMinimap.invoke_ijjjjji,
  invoke_ijjjjjij: DefaultMinimap.invoke_ijjjjjij,
  invoke_ijjjjjj: DefaultMinimap.invoke_ijjjjjj,
  invoke_ijjjjjji: DefaultMinimap.invoke_ijjjjjji,
  invoke_ijjjjjjiij: DefaultMinimap.invoke_ijjjjjjiij,
  invoke_ijjjjjjijii: DefaultMinimap.invoke_ijjjjjjijii,
  invoke_ijjjjjjj: DefaultMinimap.invoke_ijjjjjjj,
  invoke_ijjjjjjjfj: DefaultMinimap.invoke_ijjjjjjjfj,
  invoke_ijjjjjjjj: DefaultMinimap.invoke_ijjjjjjjj,
  invoke_ijjjjjjjji: DefaultMinimap.invoke_ijjjjjjjji,
  invoke_ijjjjjjjjj: DefaultMinimap.invoke_ijjjjjjjjj,
  invoke_ijjjjjjjjjj: DefaultMinimap.invoke_ijjjjjjjjjj,
  invoke_ijjjjjjjjjjj: DefaultMinimap.invoke_ijjjjjjjjjjj,
  invoke_ijjjjjjjjjjjjj: DefaultMinimap.invoke_ijjjjjjjjjjjjj,
  invoke_ijjjjjjjjjjjjjj: DefaultMinimap.invoke_ijjjjjjjjjjjjjj,
  invoke_jj: DefaultMinimap.invoke_jj,
  invoke_jjii: DefaultMinimap.invoke_jjii,
  invoke_jjiii: DefaultMinimap.invoke_jjiii,
  invoke_jjiiiii: DefaultMinimap.invoke_jjiiiii,
  invoke_jjiijj: DefaultMinimap.invoke_jjiijj,
  invoke_jjij: DefaultMinimap.invoke_jjij,
  invoke_jjijjjji: DefaultMinimap.invoke_jjijjjji,
  invoke_jjj: DefaultMinimap.invoke_jjj,
  invoke_jjji: DefaultMinimap.invoke_jjji,
  invoke_jjjiii: DefaultMinimap.invoke_jjjiii,
  invoke_jjjiijjj: DefaultMinimap.invoke_jjjiijjj,
  invoke_jjjj: DefaultMinimap.invoke_jjjj,
  invoke_jjjji: DefaultMinimap.invoke_jjjji,
  invoke_jjjjiijii: DefaultMinimap.invoke_jjjjiijii,
  invoke_jjjjj: DefaultMinimap.invoke_jjjjj,
  invoke_jjjjji: DefaultMinimap.invoke_jjjjji,
  invoke_jjjjjj: DefaultMinimap.invoke_jjjjjj,
  invoke_viiiiiijji: DefaultMinimap.invoke_viiiiiijji,
  invoke_viiiijjjij: DefaultMinimap.invoke_viiiijjjij,
  invoke_viiijjji: DefaultMinimap.invoke_viiijjji,
  invoke_viijj: DefaultMinimap.invoke_viijj,
  invoke_viijjiiiiiiijiijiiiii: DefaultMinimap.invoke_viijjiiiiiiijiijiiiii,
  invoke_vijjj: DefaultMinimap.invoke_vijjj,
  invoke_vijjji: DefaultMinimap.invoke_vijjji,
  invoke_vijjjij: DefaultMinimap.invoke_vijjjij,
  invoke_vj: DefaultMinimap.invoke_vj,
  invoke_vji: DefaultMinimap.invoke_vji,
  invoke_vjii: DefaultMinimap.invoke_vjii,
  invoke_vjiiii: DefaultMinimap.invoke_vjiiii,
  invoke_vjiiiiiiiiiiijjiiijiiijijijjiiiiijiiiijj: DefaultMinimap.invoke_vjiiiiiiiiiiijjiiijiiijijijjiiiiijiiiijj,
  invoke_vjiiiiiiiijjjjj: DefaultMinimap.invoke_vjiiiiiiiijjjjj,
  invoke_vjiiiij: DefaultMinimap.invoke_vjiiiij,
  invoke_vjiij: DefaultMinimap.invoke_vjiij,
  invoke_vjiijiii: DefaultMinimap.invoke_vjiijiii,
  invoke_vjiijj: DefaultMinimap.invoke_vjiijj,
  invoke_vjij: DefaultMinimap.invoke_vjij,
  invoke_vjijj: DefaultMinimap.invoke_vjijj,
  invoke_vjijjjj: DefaultMinimap.invoke_vjijjjj,
  invoke_vjj: DefaultMinimap.invoke_vjj,
  invoke_vjji: DefaultMinimap.invoke_vjji,
  invoke_vjjii: DefaultMinimap.invoke_vjjii,
  invoke_vjjiii: DefaultMinimap.invoke_vjjiii,
  invoke_vjjiiiijj: DefaultMinimap.invoke_vjjiiiijj,
  invoke_vjjiiij: DefaultMinimap.invoke_vjjiiij,
  invoke_vjjiiijj: DefaultMinimap.invoke_vjjiiijj,
  invoke_vjjij: DefaultMinimap.invoke_vjjij,
  invoke_vjjiji: DefaultMinimap.invoke_vjjiji,
  invoke_vjjijj: DefaultMinimap.invoke_vjjijj,
  invoke_vjjj: DefaultMinimap.invoke_vjjj,
  invoke_vjjji: DefaultMinimap.invoke_vjjji,
  invoke_vjjjii: DefaultMinimap.invoke_vjjjii,
  invoke_vjjjiii: DefaultMinimap.invoke_vjjjiii,
  invoke_vjjjijji: DefaultMinimap.invoke_vjjjijji,
  invoke_vjjjj: DefaultMinimap.invoke_vjjjj,
  invoke_vjjjji: DefaultMinimap.invoke_vjjjji,
  invoke_vjjjjii: DefaultMinimap.invoke_vjjjjii,
  invoke_vjjjjiij: DefaultMinimap.invoke_vjjjjiij,
  invoke_vjjjjiijj: DefaultMinimap.invoke_vjjjjiijj,
  invoke_vjjjjij: DefaultMinimap.invoke_vjjjjij,
  invoke_vjjjjj: DefaultMinimap.invoke_vjjjjj,
  dynCall_ii: DefaultMinimap.dynCall_ii,
  dynCall_iii: DefaultMinimap.dynCall_iii,
  dynCall_iiii: DefaultMinimap.dynCall_iiii,
  dynCall_iiiii: DefaultMinimap.dynCall_iiiii,
  dynCall_iiiiii: DefaultMinimap.dynCall_iiiiii,
  dynCall_iiiiiii: DefaultMinimap.dynCall_iiiiiii,
  dynCall_iiiiiiii: DefaultMinimap.dynCall_iiiiiiii,
  dynCall_iiiiiiiii: DefaultMinimap.dynCall_iiiiiiiii,
  dynCall_iiiiiiiiii: DefaultMinimap.dynCall_iiiiiiiiii,
  dynCall_iiiiiiiiiiii: DefaultMinimap.dynCall_iiiiiiiiiiii,
  dynCall_v: DefaultMinimap.dynCall_v,
  dynCall_vi: DefaultMinimap.dynCall_vi,
  dynCall_vii: DefaultMinimap.dynCall_vii,
  dynCall_viii: DefaultMinimap.dynCall_viii,
  dynCall_viiii: DefaultMinimap.dynCall_viiii,
  dynCall_viiiii: DefaultMinimap.dynCall_viiiii,
  dynCall_viiiiii: DefaultMinimap.dynCall_viiiiii,
  dynCall_viiiiiii: DefaultMinimap.dynCall_viiiiiii,
  dynCall_viiiiiiii: DefaultMinimap.dynCall_viiiiiiii,
  dynCall_viiiiiiiii: DefaultMinimap.dynCall_viiiiiiiii,
  dynCall_iiji: DefaultMinimap.dynCall_iiji,
  dynCall_iji: DefaultMinimap.dynCall_iji,
  dynCall_jji: DefaultMinimap.dynCall_jji,
  dynCall_jiji: DefaultMinimap.dynCall_jiji,
  dynCall_iij: DefaultMinimap.dynCall_iij,
  dynCall_jii: DefaultMinimap.dynCall_jii,
  dynCall_ji: DefaultMinimap.dynCall_ji,
  dynCall_diiid: DefaultMinimap.dynCall_diiid,
  dynCall_iidi: DefaultMinimap.dynCall_iidi,
  dynCall_iddii: DefaultMinimap.dynCall_iddii,
  dynCall_iiiiiij: DefaultMinimap.dynCall_iiiiiij,
  dynCall_iiiiiiiiiijj: DefaultMinimap.dynCall_iiiiiiiiiijj,
  dynCall_iiiiiiiiiiji: DefaultMinimap.dynCall_iiiiiiiiiiji,
  dynCall_iiiiiiijjii: DefaultMinimap.dynCall_iiiiiiijjii,
  dynCall_iijiii: DefaultMinimap.dynCall_iijiii,
  dynCall_iiijiii: DefaultMinimap.dynCall_iiijiii,
  dynCall_iiiijj: DefaultMinimap.dynCall_iiiijj,
  dynCall_iidiii: DefaultMinimap.dynCall_iidiii,
  dynCall_fdi: DefaultMinimap.dynCall_fdi,
  dynCall_idii: DefaultMinimap.dynCall_idii,
  dynCall_iiiiiiiifi: DefaultMinimap.dynCall_iiiiiiiifi,
  dynCall_vijii: DefaultMinimap.dynCall_vijii,
  dynCall_iiiijii: DefaultMinimap.dynCall_iiiijii,
  dynCall_iiiiijiiiii: DefaultMinimap.dynCall_iiiiijiiiii,
  dynCall_fdii: DefaultMinimap.dynCall_fdii,
  dynCall_viiiiiiiiijiiii: DefaultMinimap.dynCall_viiiiiiiiijiiii,
  dynCall_id: DefaultMinimap.dynCall_id,
  dynCall_dd: DefaultMinimap.dynCall_dd,
  dynCall_viij: DefaultMinimap.dynCall_viij,
  dynCall_fdd: DefaultMinimap.dynCall_fdd,
  dynCall_iiiij: DefaultMinimap.dynCall_iiiij,
  dynCall_iiiiijiiii: DefaultMinimap.dynCall_iiiiijiiii,
  dynCall_iiijii: DefaultMinimap.dynCall_iiijii,
  dynCall_iiiijiiii: DefaultMinimap.dynCall_iiiijiiii,
  dynCall_iiiji: DefaultMinimap.dynCall_iiiji,
  dynCall_iidiiii: DefaultMinimap.dynCall_iidiiii,
  dynCall_iijii: DefaultMinimap.dynCall_iijii,
  dynCall_iijj: DefaultMinimap.dynCall_iijj,
  dynCall_iijjjjjj: DefaultMinimap.dynCall_iijjjjjj,
  dynCall_viiiiiiiiiiiiiijiiiii: DefaultMinimap.dynCall_viiiiiiiiiiiiiijiiiii,
  dynCall_viiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiijiiiiii: DefaultMinimap.dynCall_viiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiijiiiiii,
  dynCall_iiiiiiiiiiiiiiiii: DefaultMinimap.dynCall_iiiiiiiiiiiiiiiii,
  dynCall_iiiiiiiiiiiiii: DefaultMinimap.dynCall_iiiiiiiiiiiiii,
  dynCall_iiiiiiiiiiiii: DefaultMinimap.dynCall_iiiiiiiiiiiii,
  dynCall_iiiiiiiiiiiiiiii: DefaultMinimap.dynCall_iiiiiiiiiiiiiiii,
  dynCall_iiiiiiiiiii: DefaultMinimap.dynCall_iiiiiiiiiii,
  dynCall_iiiiiiiiiiiiiii: DefaultMinimap.dynCall_iiiiiiiiiiiiiii,
  dynCall_djijd: DefaultMinimap.dynCall_djijd,
  dynCall_fdj: DefaultMinimap.dynCall_fdj,
  dynCall_fdjj: DefaultMinimap.dynCall_fdjj,
  dynCall_iddjj: DefaultMinimap.dynCall_iddjj,
  dynCall_idjj: DefaultMinimap.dynCall_idjj,
  dynCall_iidjjj: DefaultMinimap.dynCall_iidjjj,
  dynCall_iijjj: DefaultMinimap.dynCall_iijjj,
  dynCall_ij: DefaultMinimap.dynCall_ij,
  dynCall_ijdj: DefaultMinimap.dynCall_ijdj,
  dynCall_ijii: DefaultMinimap.dynCall_ijii,
  dynCall_ijiii: DefaultMinimap.dynCall_ijiii,
  dynCall_ijiiii: DefaultMinimap.dynCall_ijiiii,
  dynCall_ijiiiiiii: DefaultMinimap.dynCall_ijiiiiiii,
  dynCall_ijiiiiiiji: DefaultMinimap.dynCall_ijiiiiiiji,
  dynCall_ijiiiij: DefaultMinimap.dynCall_ijiiiij,
  dynCall_ijiiiijiii: DefaultMinimap.dynCall_ijiiiijiii,
  dynCall_ijiiiijij: DefaultMinimap.dynCall_ijiiiijij,
  dynCall_ijiiij: DefaultMinimap.dynCall_ijiiij,
  dynCall_ijiiijjiiiiii: DefaultMinimap.dynCall_ijiiijjiiiiii,
  dynCall_ijiij: DefaultMinimap.dynCall_ijiij,
  dynCall_ijiiji: DefaultMinimap.dynCall_ijiiji,
  dynCall_ijiijj: DefaultMinimap.dynCall_ijiijj,
  dynCall_ijij: DefaultMinimap.dynCall_ijij,
  dynCall_ijiji: DefaultMinimap.dynCall_ijiji,
  dynCall_ijijijj: DefaultMinimap.dynCall_ijijijj,
  dynCall_ijijj: DefaultMinimap.dynCall_ijijj,
  dynCall_ijijjj: DefaultMinimap.dynCall_ijijjj,
  dynCall_ijijjjj: DefaultMinimap.dynCall_ijijjjj,
  dynCall_ijj: DefaultMinimap.dynCall_ijj,
  dynCall_ijji: DefaultMinimap.dynCall_ijji,
  dynCall_ijjii: DefaultMinimap.dynCall_ijjii,
  dynCall_ijjiiiij: DefaultMinimap.dynCall_ijjiiiij,
  dynCall_ijjiiiijjii: DefaultMinimap.dynCall_ijjiiiijjii,
  dynCall_ijjiiij: DefaultMinimap.dynCall_ijjiiij,
  dynCall_ijjiiijjji: DefaultMinimap.dynCall_ijjiiijjji,
  dynCall_ijjiij: DefaultMinimap.dynCall_ijjiij,
  dynCall_ijjiijiiii: DefaultMinimap.dynCall_ijjiijiiii,
  dynCall_ijjiijiiiii: DefaultMinimap.dynCall_ijjiijiiiii,
  dynCall_ijjiijiiiiji: DefaultMinimap.dynCall_ijjiijiiiiji,
  dynCall_ijjiijiiiijii: DefaultMinimap.dynCall_ijjiijiiiijii,
  dynCall_ijjiijiiiijiij: DefaultMinimap.dynCall_ijjiijiiiijiij,
  dynCall_ijjiijiiiijj: DefaultMinimap.dynCall_ijjiijiiiijj,
  dynCall_ijjiijjjjiiiiiiii: DefaultMinimap.dynCall_ijjiijjjjiiiiiiii,
  dynCall_ijjiijjjjjjjiiii: DefaultMinimap.dynCall_ijjiijjjjjjjiiii,
  dynCall_ijjij: DefaultMinimap.dynCall_ijjij,
  dynCall_ijjiji: DefaultMinimap.dynCall_ijjiji,
  dynCall_ijjijiii: DefaultMinimap.dynCall_ijjijiii,
  dynCall_ijjijj: DefaultMinimap.dynCall_ijjijj,
  dynCall_ijjijjj: DefaultMinimap.dynCall_ijjijjj,
  dynCall_ijjj: DefaultMinimap.dynCall_ijjj,
  dynCall_ijjji: DefaultMinimap.dynCall_ijjji,
  dynCall_ijjjii: DefaultMinimap.dynCall_ijjjii,
  dynCall_ijjjiiiiiiii: DefaultMinimap.dynCall_ijjjiiiiiiii,
  dynCall_ijjjiiiji: DefaultMinimap.dynCall_ijjjiiiji,
  dynCall_ijjjiiijj: DefaultMinimap.dynCall_ijjjiiijj,
  dynCall_ijjjij: DefaultMinimap.dynCall_ijjjij,
  dynCall_ijjjijj: DefaultMinimap.dynCall_ijjjijj,
  dynCall_ijjjijji: DefaultMinimap.dynCall_ijjjijji,
  dynCall_ijjjj: DefaultMinimap.dynCall_ijjjj,
  dynCall_ijjjji: DefaultMinimap.dynCall_ijjjji,
  dynCall_ijjjjii: DefaultMinimap.dynCall_ijjjjii,
  dynCall_ijjjjj: DefaultMinimap.dynCall_ijjjjj,
  dynCall_ijjjjji: DefaultMinimap.dynCall_ijjjjji,
  dynCall_ijjjjjij: DefaultMinimap.dynCall_ijjjjjij,
  dynCall_ijjjjjj: DefaultMinimap.dynCall_ijjjjjj,
  dynCall_ijjjjjji: DefaultMinimap.dynCall_ijjjjjji,
  dynCall_ijjjjjjiij: DefaultMinimap.dynCall_ijjjjjjiij,
  dynCall_ijjjjjjijii: DefaultMinimap.dynCall_ijjjjjjijii,
  dynCall_ijjjjjjj: DefaultMinimap.dynCall_ijjjjjjj,
  dynCall_ijjjjjjjfj: DefaultMinimap.dynCall_ijjjjjjjfj,
  dynCall_ijjjjjjjj: DefaultMinimap.dynCall_ijjjjjjjj,
  dynCall_ijjjjjjjji: DefaultMinimap.dynCall_ijjjjjjjji,
  dynCall_ijjjjjjjjj: DefaultMinimap.dynCall_ijjjjjjjjj,
  dynCall_ijjjjjjjjjj: DefaultMinimap.dynCall_ijjjjjjjjjj,
  dynCall_ijjjjjjjjjjj: DefaultMinimap.dynCall_ijjjjjjjjjjj,
  dynCall_ijjjjjjjjjjjjj: DefaultMinimap.dynCall_ijjjjjjjjjjjjj,
  dynCall_ijjjjjjjjjjjjjj: DefaultMinimap.dynCall_ijjjjjjjjjjjjjj,
  dynCall_jj: DefaultMinimap.dynCall_jj,
  dynCall_jjii: DefaultMinimap.dynCall_jjii,
  dynCall_jjiii: DefaultMinimap.dynCall_jjiii,
  dynCall_jjiiiii: DefaultMinimap.dynCall_jjiiiii,
  dynCall_jjiijj: DefaultMinimap.dynCall_jjiijj,
  dynCall_jjij: DefaultMinimap.dynCall_jjij,
  dynCall_jjijjjji: DefaultMinimap.dynCall_jjijjjji,
  dynCall_jjj: DefaultMinimap.dynCall_jjj,
  dynCall_jjji: DefaultMinimap.dynCall_jjji,
  dynCall_jjjiii: DefaultMinimap.dynCall_jjjiii,
  dynCall_jjjiijjj: DefaultMinimap.dynCall_jjjiijjj,
  dynCall_jjjj: DefaultMinimap.dynCall_jjjj,
  dynCall_jjjji: DefaultMinimap.dynCall_jjjji,
  dynCall_jjjjiijii: DefaultMinimap.dynCall_jjjjiijii,
  dynCall_jjjjj: DefaultMinimap.dynCall_jjjjj,
  dynCall_jjjjji: DefaultMinimap.dynCall_jjjjji,
  dynCall_jjjjjj: DefaultMinimap.dynCall_jjjjjj,
  dynCall_viiiiiijji: DefaultMinimap.dynCall_viiiiiijji,
  dynCall_viiiijjjij: DefaultMinimap.dynCall_viiiijjjij,
  dynCall_viiijjji: DefaultMinimap.dynCall_viiijjji,
  dynCall_viijj: DefaultMinimap.dynCall_viijj,
  dynCall_viijjiiiiiiijiijiiiii: DefaultMinimap.dynCall_viijjiiiiiiijiijiiiii,
  dynCall_vijjj: DefaultMinimap.dynCall_vijjj,
  dynCall_vijjji: DefaultMinimap.dynCall_vijjji,
  dynCall_vijjjij: DefaultMinimap.dynCall_vijjjij,
  dynCall_vj: DefaultMinimap.dynCall_vj,
  dynCall_vji: DefaultMinimap.dynCall_vji,
  dynCall_vjii: DefaultMinimap.dynCall_vjii,
  dynCall_vjiiii: DefaultMinimap.dynCall_vjiiii,
  dynCall_vjiiiiiiiiiiijjiiijiiijijijjiiiiijiiiijj: DefaultMinimap.dynCall_vjiiiiiiiiiiijjiiijiiijijijjiiiiijiiiijj,
  dynCall_vjiiiiiiiijjjjj: DefaultMinimap.dynCall_vjiiiiiiiijjjjj,
  dynCall_vjiiiij: DefaultMinimap.dynCall_vjiiiij,
  dynCall_vjiij: DefaultMinimap.dynCall_vjiij,
  dynCall_vjiijiii: DefaultMinimap.dynCall_vjiijiii,
  dynCall_vjiijj: DefaultMinimap.dynCall_vjiijj,
  dynCall_vjij: DefaultMinimap.dynCall_vjij,
  dynCall_vjijj: DefaultMinimap.dynCall_vjijj,
  dynCall_vjijjjj: DefaultMinimap.dynCall_vjijjjj,
  dynCall_vjj: DefaultMinimap.dynCall_vjj,
  dynCall_vjji: DefaultMinimap.dynCall_vjji,
  dynCall_vjjii: DefaultMinimap.dynCall_vjjii,
  dynCall_vjjiii: DefaultMinimap.dynCall_vjjiii,
  dynCall_vjjiiiijj: DefaultMinimap.dynCall_vjjiiiijj,
  dynCall_vjjiiij: DefaultMinimap.dynCall_vjjiiij,
  dynCall_vjjiiijj: DefaultMinimap.dynCall_vjjiiijj,
  dynCall_vjjij: DefaultMinimap.dynCall_vjjij,
  dynCall_vjjiji: DefaultMinimap.dynCall_vjjiji,
  dynCall_vjjijj: DefaultMinimap.dynCall_vjjijj,
  dynCall_vjjj: DefaultMinimap.dynCall_vjjj,
  dynCall_vjjji: DefaultMinimap.dynCall_vjjji,
  dynCall_vjjjii: DefaultMinimap.dynCall_vjjjii,
  dynCall_vjjjiii: DefaultMinimap.dynCall_vjjjiii,
  dynCall_vjjjijji: DefaultMinimap.dynCall_vjjjijji,
  dynCall_vjjjj: DefaultMinimap.dynCall_vjjjj,
  dynCall_vjjjji: DefaultMinimap.dynCall_vjjjji,
  dynCall_vjjjjii: DefaultMinimap.dynCall_vjjjjii,
  dynCall_vjjjjiij: DefaultMinimap.dynCall_vjjjjiij,
  dynCall_vjjjjiijj: DefaultMinimap.dynCall_vjjjjiijj,
  dynCall_vjjjjij: DefaultMinimap.dynCall_vjjjjij,
  dynCall_vjjjjj: DefaultMinimap.dynCall_vjjjjj,
  malloc: DefaultMinimap.malloc,
  free: DefaultMinimap.free,
} as const

export type WasmImports<T extends number | bigint> = {
  [DefaultMinimap.fd_close]: (a0: number) => number
  [DefaultMinimap.fd_write]: (a0: number, a1: T, a2: T, a3: T) => number
  [DefaultMinimap.fd_read]: (a0: number, a1: T, a2: T, a3: T) => number
  [DefaultMinimap.fd_seek]: (a0: number, a1: bigint, a2: number, a3: T) => number
  [DefaultMinimap.environ_get]: (a0: T, a1: T) => number
  [DefaultMinimap.environ_sizes_get]: (a0: T, a1: T) => number
  [DefaultMinimap.proc_exit]: (a0: number) => void
  [DefaultMinimap.fd_pread]: (a0: number, a1: T, a2: T, a3: bigint, a4: T) => number
  [DefaultMinimap.fd_pwrite]: (a0: number, a1: T, a2: T, a3: bigint, a4: T) => number
  [DefaultMinimap.clock_time_get]: (a0: number, a1: bigint, a2: T) => number
  [DefaultMinimap._tzset_js]: (a0: T, a1: T, a2: T, a3: T) => void
  [DefaultMinimap._localtime_js]: (a0: bigint, a1: T) => void
  [DefaultMinimap._gmtime_js]: (a0: bigint, a1: T) => void
  [DefaultMinimap.__syscall_fcntl64]: (a0: number, a1: number, a2: T) => number
  [DefaultMinimap.__syscall_ioctl]: (a0: number, a1: number, a2: T) => number
  [DefaultMinimap.__syscall_openat]: (a0: number, a1: T, a2: number, a3: T) => number
  [DefaultMinimap.__syscall_stat64]: (a0: T, a1: T) => number
  [DefaultMinimap.__syscall_unlinkat]: (a0: number, a1: T, a2: number) => number
  [DefaultMinimap.__syscall_rmdir]: (a0: T) => number
  [DefaultMinimap.__syscall_getdents64]: (a0: number, a1: T, a2: T) => number
  [DefaultMinimap._emscripten_runtime_keepalive_clear]: () => void
  [DefaultMinimap._setitimer_js]: (a0: number, a1: number) => number
  [DefaultMinimap._mmap_js]: (a0: T, a1: number, a2: number, a3: number, a4: bigint, a5: T, a6: T) => number
  [DefaultMinimap._munmap_js]: (a0: T, a1: T, a2: number, a3: number, a4: number, a5: bigint) => number
  [DefaultMinimap.emscripten_resize_heap]: (a0: T) => number
  [DefaultMinimap.emscripten_date_now]: () => number
  [DefaultMinimap._abort_js]: () => void
  [DefaultMinimap._emscripten_throw_longjmp]: () => void
  [DefaultMinimap.__syscall_getcwd]: (a0: T, a1: T) => number
  [DefaultMinimap.__assert_fail]: (a0: T, a1: T, a2: number, a3: T) => void
  [DefaultMinimap.__syscall_dup]: (a0: number) => number
  [DefaultMinimap.__syscall_dup3]: (a0: number, a1: number, a2: number) => number
  [DefaultMinimap.__syscall_fstat64]: (a0: number, a1: T) => number
  [DefaultMinimap.__syscall_lstat64]: (a0: T, a1: T) => number
  [DefaultMinimap.__syscall_newfstatat]: (a0: number, a1: T, a2: T, a3: number) => number
  [DefaultMinimap.__syscall_renameat]: (a0: number, a1: T, a2: number, a3: T) => number
  [DefaultMinimap.__cxa_throw]: (a0: T, a1: T, a2: T) => void
  [DefaultMinimap.exit]: (a0: number) => void
  [DefaultMinimap.log_str]: (a0: T, a1: number) => void
  [DefaultMinimap.invoke_ii]: (a0: T, a1: number) => number
  [DefaultMinimap.invoke_iii]: (a0: T, a1: number, a2: number) => number
  [DefaultMinimap.invoke_iiii]: (a0: T, a1: number, a2: number, a3: number) => number
  [DefaultMinimap.invoke_iiiii]: (a0: T, a1: number, a2: number, a3: number, a4: number) => number
  [DefaultMinimap.invoke_iiiiii]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number) => number
  [DefaultMinimap.invoke_iiiiiii]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number, a6: number) => number
  [DefaultMinimap.invoke_iiiiiiii]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number, a6: number, a7: number) => number
  [DefaultMinimap.invoke_iiiiiiiii]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number, a6: number, a7: number, a8: number) => number
  [DefaultMinimap.invoke_iiiiiiiiii]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number, a6: number, a7: number, a8: number, a9: number) => number
  [DefaultMinimap.invoke_iiiiiiiiiiii]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number, a6: number, a7: number, a8: number, a9: number, a10: number, a11: number) => number
  [DefaultMinimap.invoke_v]: (a0: T) => void
  [DefaultMinimap.invoke_vi]: (a0: T, a1: number) => void
  [DefaultMinimap.invoke_vii]: (a0: T, a1: number, a2: number) => void
  [DefaultMinimap.invoke_viii]: (a0: T, a1: number, a2: number, a3: number) => void
  [DefaultMinimap.invoke_viiii]: (a0: T, a1: number, a2: number, a3: number, a4: number) => void
  [DefaultMinimap.invoke_viiiii]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number) => void
  [DefaultMinimap.invoke_viiiiii]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number, a6: number) => void
  [DefaultMinimap.invoke_viiiiiii]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number, a6: number, a7: number) => void
  [DefaultMinimap.invoke_viiiiiiii]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number, a6: number, a7: number, a8: number) => void
  [DefaultMinimap.invoke_viiiiiiiii]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number, a6: number, a7: number, a8: number, a9: number) => void
  [DefaultMinimap.invoke_iiji]: (a0: T, a1: number, a2: bigint, a3: number) => number
  [DefaultMinimap.invoke_iji]: (a0: T, a1: bigint, a2: number) => number
  [DefaultMinimap.invoke_jji]: (a0: T, a1: bigint, a2: number) => bigint
  [DefaultMinimap.invoke_jiji]: (a0: T, a1: number, a2: bigint, a3: number) => bigint
  [DefaultMinimap.invoke_iij]: (a0: T, a1: number, a2: bigint) => number
  [DefaultMinimap.invoke_jii]: (a0: T, a1: number, a2: number) => bigint
  [DefaultMinimap.invoke_ji]: (a0: T, a1: number) => bigint
  [DefaultMinimap.invoke_diiid]: (a0: T, a1: number, a2: number, a3: number, a4: number) => number
  [DefaultMinimap.invoke_iidi]: (a0: T, a1: number, a2: number, a3: number) => number
  [DefaultMinimap.invoke_iddii]: (a0: T, a1: number, a2: number, a3: number, a4: number) => number
  [DefaultMinimap.invoke_iiiiiij]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number, a6: bigint) => number
  [DefaultMinimap.invoke_iiiiiiiiiijj]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number, a6: number, a7: number, a8: number, a9: number, a10: bigint, a11: bigint) => number
  [DefaultMinimap.invoke_iiiiiiiiiiji]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number, a6: number, a7: number, a8: number, a9: number, a10: bigint, a11: number) => number
  [DefaultMinimap.invoke_iiiiiiijjii]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number, a6: number, a7: bigint, a8: bigint, a9: number, a10: number) => number
  [DefaultMinimap.invoke_iijiii]: (a0: T, a1: number, a2: bigint, a3: number, a4: number, a5: number) => number
  [DefaultMinimap.invoke_iiijiii]: (a0: T, a1: number, a2: number, a3: bigint, a4: number, a5: number, a6: number) => number
  [DefaultMinimap.invoke_iiiijj]: (a0: T, a1: number, a2: number, a3: number, a4: bigint, a5: bigint) => number
  [DefaultMinimap.invoke_iidiii]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number) => number
  [DefaultMinimap.invoke_fdi]: (a0: T, a1: number, a2: number) => number
  [DefaultMinimap.invoke_idii]: (a0: T, a1: number, a2: number, a3: number) => number
  [DefaultMinimap.invoke_iiiiiiiifi]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number, a6: number, a7: number, a8: number, a9: number) => number
  [DefaultMinimap.invoke_vijii]: (a0: T, a1: number, a2: bigint, a3: number, a4: number) => void
  [DefaultMinimap.invoke_iiiijii]: (a0: T, a1: number, a2: number, a3: number, a4: bigint, a5: number, a6: number) => number
  [DefaultMinimap.invoke_iiiiijiiiii]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: bigint, a6: number, a7: number, a8: number, a9: number, a10: number) => number
  [DefaultMinimap.invoke_fdii]: (a0: T, a1: number, a2: number, a3: number) => number
  [DefaultMinimap.invoke_viiiiiiiiijiiii]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number, a6: number, a7: number, a8: number, a9: number, a10: bigint, a11: number, a12: number, a13: number, a14: number) => void
  [DefaultMinimap.invoke_id]: (a0: T, a1: number) => number
  [DefaultMinimap.invoke_dd]: (a0: T, a1: number) => number
  [DefaultMinimap.invoke_viij]: (a0: T, a1: number, a2: number, a3: bigint) => void
  [DefaultMinimap.invoke_fdd]: (a0: T, a1: number, a2: number) => number
  [DefaultMinimap.invoke_iiiij]: (a0: T, a1: number, a2: number, a3: number, a4: bigint) => number
  [DefaultMinimap.invoke_iiiiijiiii]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: bigint, a6: number, a7: number, a8: number, a9: number) => number
  [DefaultMinimap.invoke_iiijii]: (a0: T, a1: number, a2: number, a3: bigint, a4: number, a5: number) => number
  [DefaultMinimap.invoke_iiiijiiii]: (a0: T, a1: number, a2: number, a3: number, a4: bigint, a5: number, a6: number, a7: number, a8: number) => number
  [DefaultMinimap.invoke_iiiji]: (a0: T, a1: number, a2: number, a3: bigint, a4: number) => number
  [DefaultMinimap.invoke_iidiiii]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number, a6: number) => number
  [DefaultMinimap.invoke_iijii]: (a0: T, a1: number, a2: bigint, a3: number, a4: number) => number
  [DefaultMinimap.invoke_iijj]: (a0: T, a1: number, a2: bigint, a3: bigint) => number
  [DefaultMinimap.invoke_iijjjjjj]: (a0: T, a1: number, a2: bigint, a3: bigint, a4: bigint, a5: bigint, a6: bigint, a7: bigint) => number
  [DefaultMinimap.invoke_viiiiiiiiiiiiiijiiiii]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number, a6: number, a7: number, a8: number, a9: number, a10: number, a11: number, a12: number, a13: number, a14: number, a15: bigint, a16: number, a17: number, a18: number, a19: number, a20: number) => void
  [DefaultMinimap.invoke_viiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiijiiiiii]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number, a6: number, a7: number, a8: number, a9: number, a10: number, a11: number, a12: number, a13: number, a14: number, a15: number, a16: number, a17: number, a18: number, a19: number, a20: number, a21: number, a22: number, a23: number, a24: number, a25: number, a26: number, a27: number, a28: number, a29: number, a30: number, a31: number, a32: number, a33: bigint, a34: number, a35: number, a36: number, a37: number, a38: number, a39: number) => void
  [DefaultMinimap.invoke_iiiiiiiiiiiiiiiii]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number, a6: number, a7: number, a8: number, a9: number, a10: number, a11: number, a12: number, a13: number, a14: number, a15: number, a16: number) => number
  [DefaultMinimap.invoke_iiiiiiiiiiiiii]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number, a6: number, a7: number, a8: number, a9: number, a10: number, a11: number, a12: number, a13: number) => number
  [DefaultMinimap.invoke_iiiiiiiiiiiii]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number, a6: number, a7: number, a8: number, a9: number, a10: number, a11: number, a12: number) => number
  [DefaultMinimap.invoke_iiiiiiiiiiiiiiii]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number, a6: number, a7: number, a8: number, a9: number, a10: number, a11: number, a12: number, a13: number, a14: number, a15: number) => number
  [DefaultMinimap.invoke_iiiiiiiiiii]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number, a6: number, a7: number, a8: number, a9: number, a10: number) => number
  [DefaultMinimap.invoke_iiiiiiiiiiiiiii]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number, a6: number, a7: number, a8: number, a9: number, a10: number, a11: number, a12: number, a13: number, a14: number) => number
  [DefaultMinimap.invoke_djijd]: (a0: T, a1: bigint, a2: number, a3: bigint, a4: number) => number
  [DefaultMinimap.invoke_fdj]: (a0: T, a1: number, a2: bigint) => number
  [DefaultMinimap.invoke_fdjj]: (a0: T, a1: number, a2: bigint, a3: bigint) => number
  [DefaultMinimap.invoke_iddjj]: (a0: T, a1: number, a2: number, a3: bigint, a4: bigint) => number
  [DefaultMinimap.invoke_idjj]: (a0: T, a1: number, a2: bigint, a3: bigint) => number
  [DefaultMinimap.invoke_iidjjj]: (a0: T, a1: number, a2: number, a3: bigint, a4: bigint, a5: bigint) => number
  [DefaultMinimap.invoke_iijjj]: (a0: T, a1: number, a2: bigint, a3: bigint, a4: bigint) => number
  [DefaultMinimap.invoke_ij]: (a0: T, a1: bigint) => number
  [DefaultMinimap.invoke_ijdj]: (a0: T, a1: bigint, a2: number, a3: bigint) => number
  [DefaultMinimap.invoke_ijii]: (a0: T, a1: bigint, a2: number, a3: number) => number
  [DefaultMinimap.invoke_ijiii]: (a0: T, a1: bigint, a2: number, a3: number, a4: number) => number
  [DefaultMinimap.invoke_ijiiii]: (a0: T, a1: bigint, a2: number, a3: number, a4: number, a5: number) => number
  [DefaultMinimap.invoke_ijiiiiiii]: (a0: T, a1: bigint, a2: number, a3: number, a4: number, a5: number, a6: number, a7: number, a8: number) => number
  [DefaultMinimap.invoke_ijiiiiiiji]: (a0: T, a1: bigint, a2: number, a3: number, a4: number, a5: number, a6: number, a7: number, a8: bigint, a9: number) => number
  [DefaultMinimap.invoke_ijiiiij]: (a0: T, a1: bigint, a2: number, a3: number, a4: number, a5: number, a6: bigint) => number
  [DefaultMinimap.invoke_ijiiiijiii]: (a0: T, a1: bigint, a2: number, a3: number, a4: number, a5: number, a6: bigint, a7: number, a8: number, a9: number) => number
  [DefaultMinimap.invoke_ijiiiijij]: (a0: T, a1: bigint, a2: number, a3: number, a4: number, a5: number, a6: bigint, a7: number, a8: bigint) => number
  [DefaultMinimap.invoke_ijiiij]: (a0: T, a1: bigint, a2: number, a3: number, a4: number, a5: bigint) => number
  [DefaultMinimap.invoke_ijiiijjiiiiii]: (a0: T, a1: bigint, a2: number, a3: number, a4: number, a5: bigint, a6: bigint, a7: number, a8: number, a9: number, a10: number, a11: number, a12: number) => number
  [DefaultMinimap.invoke_ijiij]: (a0: T, a1: bigint, a2: number, a3: number, a4: bigint) => number
  [DefaultMinimap.invoke_ijiiji]: (a0: T, a1: bigint, a2: number, a3: number, a4: bigint, a5: number) => number
  [DefaultMinimap.invoke_ijiijj]: (a0: T, a1: bigint, a2: number, a3: number, a4: bigint, a5: bigint) => number
  [DefaultMinimap.invoke_ijij]: (a0: T, a1: bigint, a2: number, a3: bigint) => number
  [DefaultMinimap.invoke_ijiji]: (a0: T, a1: bigint, a2: number, a3: bigint, a4: number) => number
  [DefaultMinimap.invoke_ijijijj]: (a0: T, a1: bigint, a2: number, a3: bigint, a4: number, a5: bigint, a6: bigint) => number
  [DefaultMinimap.invoke_ijijj]: (a0: T, a1: bigint, a2: number, a3: bigint, a4: bigint) => number
  [DefaultMinimap.invoke_ijijjj]: (a0: T, a1: bigint, a2: number, a3: bigint, a4: bigint, a5: bigint) => number
  [DefaultMinimap.invoke_ijijjjj]: (a0: T, a1: bigint, a2: number, a3: bigint, a4: bigint, a5: bigint, a6: bigint) => number
  [DefaultMinimap.invoke_ijj]: (a0: T, a1: bigint, a2: bigint) => number
  [DefaultMinimap.invoke_ijji]: (a0: T, a1: bigint, a2: bigint, a3: number) => number
  [DefaultMinimap.invoke_ijjii]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: number) => number
  [DefaultMinimap.invoke_ijjiiiij]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: number, a5: number, a6: number, a7: bigint) => number
  [DefaultMinimap.invoke_ijjiiiijjii]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: number, a5: number, a6: number, a7: bigint, a8: bigint, a9: number, a10: number) => number
  [DefaultMinimap.invoke_ijjiiij]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: number, a5: number, a6: bigint) => number
  [DefaultMinimap.invoke_ijjiiijjji]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: number, a5: number, a6: bigint, a7: bigint, a8: bigint, a9: number) => number
  [DefaultMinimap.invoke_ijjiij]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: number, a5: bigint) => number
  [DefaultMinimap.invoke_ijjiijiiii]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: number, a5: bigint, a6: number, a7: number, a8: number, a9: number) => number
  [DefaultMinimap.invoke_ijjiijiiiii]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: number, a5: bigint, a6: number, a7: number, a8: number, a9: number, a10: number) => number
  [DefaultMinimap.invoke_ijjiijiiiiji]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: number, a5: bigint, a6: number, a7: number, a8: number, a9: number, a10: bigint, a11: number) => number
  [DefaultMinimap.invoke_ijjiijiiiijii]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: number, a5: bigint, a6: number, a7: number, a8: number, a9: number, a10: bigint, a11: number, a12: number) => number
  [DefaultMinimap.invoke_ijjiijiiiijiij]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: number, a5: bigint, a6: number, a7: number, a8: number, a9: number, a10: bigint, a11: number, a12: number, a13: bigint) => number
  [DefaultMinimap.invoke_ijjiijiiiijj]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: number, a5: bigint, a6: number, a7: number, a8: number, a9: number, a10: bigint, a11: bigint) => number
  [DefaultMinimap.invoke_ijjiijjjjiiiiiiii]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: number, a5: bigint, a6: bigint, a7: bigint, a8: bigint, a9: number, a10: number, a11: number, a12: number, a13: number, a14: number, a15: number, a16: number) => number
  [DefaultMinimap.invoke_ijjiijjjjjjjiiii]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: number, a5: bigint, a6: bigint, a7: bigint, a8: bigint, a9: bigint, a10: bigint, a11: bigint, a12: number, a13: number, a14: number, a15: number) => number
  [DefaultMinimap.invoke_ijjij]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: bigint) => number
  [DefaultMinimap.invoke_ijjiji]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: bigint, a5: number) => number
  [DefaultMinimap.invoke_ijjijiii]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: bigint, a5: number, a6: number, a7: number) => number
  [DefaultMinimap.invoke_ijjijj]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: bigint, a5: bigint) => number
  [DefaultMinimap.invoke_ijjijjj]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: bigint, a5: bigint, a6: bigint) => number
  [DefaultMinimap.invoke_ijjj]: (a0: T, a1: bigint, a2: bigint, a3: bigint) => number
  [DefaultMinimap.invoke_ijjji]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: number) => number
  [DefaultMinimap.invoke_ijjjii]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: number, a5: number) => number
  [DefaultMinimap.invoke_ijjjiiiiiiii]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: number, a5: number, a6: number, a7: number, a8: number, a9: number, a10: number, a11: number) => number
  [DefaultMinimap.invoke_ijjjiiiji]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: number, a5: number, a6: number, a7: bigint, a8: number) => number
  [DefaultMinimap.invoke_ijjjiiijj]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: number, a5: number, a6: number, a7: bigint, a8: bigint) => number
  [DefaultMinimap.invoke_ijjjij]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: number, a5: bigint) => number
  [DefaultMinimap.invoke_ijjjijj]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: number, a5: bigint, a6: bigint) => number
  [DefaultMinimap.invoke_ijjjijji]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: number, a5: bigint, a6: bigint, a7: number) => number
  [DefaultMinimap.invoke_ijjjj]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint) => number
  [DefaultMinimap.invoke_ijjjji]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint, a5: number) => number
  [DefaultMinimap.invoke_ijjjjii]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint, a5: number, a6: number) => number
  [DefaultMinimap.invoke_ijjjjj]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint, a5: bigint) => number
  [DefaultMinimap.invoke_ijjjjji]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint, a5: bigint, a6: number) => number
  [DefaultMinimap.invoke_ijjjjjij]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint, a5: bigint, a6: number, a7: bigint) => number
  [DefaultMinimap.invoke_ijjjjjj]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint, a5: bigint, a6: bigint) => number
  [DefaultMinimap.invoke_ijjjjjji]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint, a5: bigint, a6: bigint, a7: number) => number
  [DefaultMinimap.invoke_ijjjjjjiij]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint, a5: bigint, a6: bigint, a7: number, a8: number, a9: bigint) => number
  [DefaultMinimap.invoke_ijjjjjjijii]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint, a5: bigint, a6: bigint, a7: number, a8: bigint, a9: number, a10: number) => number
  [DefaultMinimap.invoke_ijjjjjjj]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint, a5: bigint, a6: bigint, a7: bigint) => number
  [DefaultMinimap.invoke_ijjjjjjjfj]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint, a5: bigint, a6: bigint, a7: bigint, a8: number, a9: bigint) => number
  [DefaultMinimap.invoke_ijjjjjjjj]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint, a5: bigint, a6: bigint, a7: bigint, a8: bigint) => number
  [DefaultMinimap.invoke_ijjjjjjjji]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint, a5: bigint, a6: bigint, a7: bigint, a8: bigint, a9: number) => number
  [DefaultMinimap.invoke_ijjjjjjjjj]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint, a5: bigint, a6: bigint, a7: bigint, a8: bigint, a9: bigint) => number
  [DefaultMinimap.invoke_ijjjjjjjjjj]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint, a5: bigint, a6: bigint, a7: bigint, a8: bigint, a9: bigint, a10: bigint) => number
  [DefaultMinimap.invoke_ijjjjjjjjjjj]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint, a5: bigint, a6: bigint, a7: bigint, a8: bigint, a9: bigint, a10: bigint, a11: bigint) => number
  [DefaultMinimap.invoke_ijjjjjjjjjjjjj]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint, a5: bigint, a6: bigint, a7: bigint, a8: bigint, a9: bigint, a10: bigint, a11: bigint, a12: bigint, a13: bigint) => number
  [DefaultMinimap.invoke_ijjjjjjjjjjjjjj]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint, a5: bigint, a6: bigint, a7: bigint, a8: bigint, a9: bigint, a10: bigint, a11: bigint, a12: bigint, a13: bigint, a14: bigint) => number
  [DefaultMinimap.invoke_jj]: (a0: T, a1: bigint) => bigint
  [DefaultMinimap.invoke_jjii]: (a0: T, a1: bigint, a2: number, a3: number) => bigint
  [DefaultMinimap.invoke_jjiii]: (a0: T, a1: bigint, a2: number, a3: number, a4: number) => bigint
  [DefaultMinimap.invoke_jjiiiii]: (a0: T, a1: bigint, a2: number, a3: number, a4: number, a5: number, a6: number) => bigint
  [DefaultMinimap.invoke_jjiijj]: (a0: T, a1: bigint, a2: number, a3: number, a4: bigint, a5: bigint) => bigint
  [DefaultMinimap.invoke_jjij]: (a0: T, a1: bigint, a2: number, a3: bigint) => bigint
  [DefaultMinimap.invoke_jjijjjji]: (a0: T, a1: bigint, a2: number, a3: bigint, a4: bigint, a5: bigint, a6: bigint, a7: number) => bigint
  [DefaultMinimap.invoke_jjj]: (a0: T, a1: bigint, a2: bigint) => bigint
  [DefaultMinimap.invoke_jjji]: (a0: T, a1: bigint, a2: bigint, a3: number) => bigint
  [DefaultMinimap.invoke_jjjiii]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: number, a5: number) => bigint
  [DefaultMinimap.invoke_jjjiijjj]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: number, a5: bigint, a6: bigint, a7: bigint) => bigint
  [DefaultMinimap.invoke_jjjj]: (a0: T, a1: bigint, a2: bigint, a3: bigint) => bigint
  [DefaultMinimap.invoke_jjjji]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: number) => bigint
  [DefaultMinimap.invoke_jjjjiijii]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: number, a5: number, a6: bigint, a7: number, a8: number) => bigint
  [DefaultMinimap.invoke_jjjjj]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint) => bigint
  [DefaultMinimap.invoke_jjjjji]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint, a5: number) => bigint
  [DefaultMinimap.invoke_jjjjjj]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint, a5: bigint) => bigint
  [DefaultMinimap.invoke_viiiiiijji]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number, a6: number, a7: bigint, a8: bigint, a9: number) => void
  [DefaultMinimap.invoke_viiiijjjij]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: bigint, a6: bigint, a7: bigint, a8: number, a9: bigint) => void
  [DefaultMinimap.invoke_viiijjji]: (a0: T, a1: number, a2: number, a3: number, a4: bigint, a5: bigint, a6: bigint, a7: number) => void
  [DefaultMinimap.invoke_viijj]: (a0: T, a1: number, a2: number, a3: bigint, a4: bigint) => void
  [DefaultMinimap.invoke_viijjiiiiiiijiijiiiii]: (a0: T, a1: number, a2: number, a3: bigint, a4: bigint, a5: number, a6: number, a7: number, a8: number, a9: number, a10: number, a11: number, a12: bigint, a13: number, a14: number, a15: bigint, a16: number, a17: number, a18: number, a19: number, a20: number) => void
  [DefaultMinimap.invoke_vijjj]: (a0: T, a1: number, a2: bigint, a3: bigint, a4: bigint) => void
  [DefaultMinimap.invoke_vijjji]: (a0: T, a1: number, a2: bigint, a3: bigint, a4: bigint, a5: number) => void
  [DefaultMinimap.invoke_vijjjij]: (a0: T, a1: number, a2: bigint, a3: bigint, a4: bigint, a5: number, a6: bigint) => void
  [DefaultMinimap.invoke_vj]: (a0: T, a1: bigint) => void
  [DefaultMinimap.invoke_vji]: (a0: T, a1: bigint, a2: number) => void
  [DefaultMinimap.invoke_vjii]: (a0: T, a1: bigint, a2: number, a3: number) => void
  [DefaultMinimap.invoke_vjiiii]: (a0: T, a1: bigint, a2: number, a3: number, a4: number, a5: number) => void
  [DefaultMinimap.invoke_vjiiiiiiiiiiijjiiijiiijijijjiiiiijiiiijj]: (a0: T, a1: bigint, a2: number, a3: number, a4: number, a5: number, a6: number, a7: number, a8: number, a9: number, a10: number, a11: number, a12: number, a13: bigint, a14: bigint, a15: number, a16: number, a17: number, a18: bigint, a19: number, a20: number, a21: number, a22: bigint, a23: number, a24: bigint, a25: number, a26: bigint, a27: bigint, a28: number, a29: number, a30: number, a31: number, a32: number, a33: bigint, a34: number, a35: number, a36: number, a37: number, a38: bigint, a39: bigint) => void
  [DefaultMinimap.invoke_vjiiiiiiiijjjjj]: (a0: T, a1: bigint, a2: number, a3: number, a4: number, a5: number, a6: number, a7: number, a8: number, a9: number, a10: bigint, a11: bigint, a12: bigint, a13: bigint, a14: bigint) => void
  [DefaultMinimap.invoke_vjiiiij]: (a0: T, a1: bigint, a2: number, a3: number, a4: number, a5: number, a6: bigint) => void
  [DefaultMinimap.invoke_vjiij]: (a0: T, a1: bigint, a2: number, a3: number, a4: bigint) => void
  [DefaultMinimap.invoke_vjiijiii]: (a0: T, a1: bigint, a2: number, a3: number, a4: bigint, a5: number, a6: number, a7: number) => void
  [DefaultMinimap.invoke_vjiijj]: (a0: T, a1: bigint, a2: number, a3: number, a4: bigint, a5: bigint) => void
  [DefaultMinimap.invoke_vjij]: (a0: T, a1: bigint, a2: number, a3: bigint) => void
  [DefaultMinimap.invoke_vjijj]: (a0: T, a1: bigint, a2: number, a3: bigint, a4: bigint) => void
  [DefaultMinimap.invoke_vjijjjj]: (a0: T, a1: bigint, a2: number, a3: bigint, a4: bigint, a5: bigint, a6: bigint) => void
  [DefaultMinimap.invoke_vjj]: (a0: T, a1: bigint, a2: bigint) => void
  [DefaultMinimap.invoke_vjji]: (a0: T, a1: bigint, a2: bigint, a3: number) => void
  [DefaultMinimap.invoke_vjjii]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: number) => void
  [DefaultMinimap.invoke_vjjiii]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: number, a5: number) => void
  [DefaultMinimap.invoke_vjjiiiijj]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: number, a5: number, a6: number, a7: bigint, a8: bigint) => void
  [DefaultMinimap.invoke_vjjiiij]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: number, a5: number, a6: bigint) => void
  [DefaultMinimap.invoke_vjjiiijj]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: number, a5: number, a6: bigint, a7: bigint) => void
  [DefaultMinimap.invoke_vjjij]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: bigint) => void
  [DefaultMinimap.invoke_vjjiji]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: bigint, a5: number) => void
  [DefaultMinimap.invoke_vjjijj]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: bigint, a5: bigint) => void
  [DefaultMinimap.invoke_vjjj]: (a0: T, a1: bigint, a2: bigint, a3: bigint) => void
  [DefaultMinimap.invoke_vjjji]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: number) => void
  [DefaultMinimap.invoke_vjjjii]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: number, a5: number) => void
  [DefaultMinimap.invoke_vjjjiii]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: number, a5: number, a6: number) => void
  [DefaultMinimap.invoke_vjjjijji]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: number, a5: bigint, a6: bigint, a7: number) => void
  [DefaultMinimap.invoke_vjjjj]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint) => void
  [DefaultMinimap.invoke_vjjjji]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint, a5: number) => void
  [DefaultMinimap.invoke_vjjjjii]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint, a5: number, a6: number) => void
  [DefaultMinimap.invoke_vjjjjiij]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint, a5: number, a6: number, a7: bigint) => void
  [DefaultMinimap.invoke_vjjjjiijj]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint, a5: number, a6: number, a7: bigint, a8: bigint) => void
  [DefaultMinimap.invoke_vjjjjij]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint, a5: number, a6: bigint) => void
  [DefaultMinimap.invoke_vjjjjj]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint, a5: bigint) => void
}

export type WasmExports<T extends number | bigint> = {
  [DefaultMinimap.__wasm_call_ctors]: () => void
  [DefaultMinimap.setThrew]: (a0: number, a1: number) => void
  [DefaultMinimap.emscripten_stack_get_current]: () => T
  [DefaultMinimap._emscripten_stack_restore]: (a0: T) => void
  [DefaultMinimap.malloc]: (a0: T) => T
  [DefaultMinimap.free]: (a0: T) => void
  [DefaultMinimap.dynCall_ii]: (a0: T, a1: number) => number
  [DefaultMinimap.dynCall_iii]: (a0: T, a1: number, a2: number) => number
  [DefaultMinimap.dynCall_iiii]: (a0: T, a1: number, a2: number, a3: number) => number
  [DefaultMinimap.dynCall_iiiii]: (a0: T, a1: number, a2: number, a3: number, a4: number) => number
  [DefaultMinimap.dynCall_iiiiii]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number) => number
  [DefaultMinimap.dynCall_iiiiiii]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number, a6: number) => number
  [DefaultMinimap.dynCall_iiiiiiii]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number, a6: number, a7: number) => number
  [DefaultMinimap.dynCall_iiiiiiiii]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number, a6: number, a7: number, a8: number) => number
  [DefaultMinimap.dynCall_iiiiiiiiii]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number, a6: number, a7: number, a8: number, a9: number) => number
  [DefaultMinimap.dynCall_iiiiiiiiiiii]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number, a6: number, a7: number, a8: number, a9: number, a10: number, a11: number) => number
  [DefaultMinimap.dynCall_v]: (a0: T) => void
  [DefaultMinimap.dynCall_vi]: (a0: T, a1: number) => void
  [DefaultMinimap.dynCall_vii]: (a0: T, a1: number, a2: number) => void
  [DefaultMinimap.dynCall_viii]: (a0: T, a1: number, a2: number, a3: number) => void
  [DefaultMinimap.dynCall_viiii]: (a0: T, a1: number, a2: number, a3: number, a4: number) => void
  [DefaultMinimap.dynCall_viiiii]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number) => void
  [DefaultMinimap.dynCall_viiiiii]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number, a6: number) => void
  [DefaultMinimap.dynCall_viiiiiii]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number, a6: number, a7: number) => void
  [DefaultMinimap.dynCall_viiiiiiii]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number, a6: number, a7: number, a8: number) => void
  [DefaultMinimap.dynCall_viiiiiiiii]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number, a6: number, a7: number, a8: number, a9: number) => void
  [DefaultMinimap.dynCall_iiji]: (a0: T, a1: number, a2: bigint, a3: number) => number
  [DefaultMinimap.dynCall_iji]: (a0: T, a1: bigint, a2: number) => number
  [DefaultMinimap.dynCall_jji]: (a0: T, a1: bigint, a2: number) => bigint
  [DefaultMinimap.dynCall_jiji]: (a0: T, a1: number, a2: bigint, a3: number) => bigint
  [DefaultMinimap.dynCall_iij]: (a0: T, a1: number, a2: bigint) => number
  [DefaultMinimap.dynCall_jii]: (a0: T, a1: number, a2: number) => bigint
  [DefaultMinimap.dynCall_ji]: (a0: T, a1: number) => bigint
  [DefaultMinimap.dynCall_diiid]: (a0: T, a1: number, a2: number, a3: number, a4: number) => number
  [DefaultMinimap.dynCall_iidi]: (a0: T, a1: number, a2: number, a3: number) => number
  [DefaultMinimap.dynCall_iddii]: (a0: T, a1: number, a2: number, a3: number, a4: number) => number
  [DefaultMinimap.dynCall_iiiiiij]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number, a6: bigint) => number
  [DefaultMinimap.dynCall_iiiiiiiiiijj]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number, a6: number, a7: number, a8: number, a9: number, a10: bigint, a11: bigint) => number
  [DefaultMinimap.dynCall_iiiiiiiiiiji]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number, a6: number, a7: number, a8: number, a9: number, a10: bigint, a11: number) => number
  [DefaultMinimap.dynCall_iiiiiiijjii]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number, a6: number, a7: bigint, a8: bigint, a9: number, a10: number) => number
  [DefaultMinimap.dynCall_iijiii]: (a0: T, a1: number, a2: bigint, a3: number, a4: number, a5: number) => number
  [DefaultMinimap.dynCall_iiijiii]: (a0: T, a1: number, a2: number, a3: bigint, a4: number, a5: number, a6: number) => number
  [DefaultMinimap.dynCall_iiiijj]: (a0: T, a1: number, a2: number, a3: number, a4: bigint, a5: bigint) => number
  [DefaultMinimap.dynCall_iidiii]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number) => number
  [DefaultMinimap.dynCall_fdi]: (a0: T, a1: number, a2: number) => number
  [DefaultMinimap.dynCall_idii]: (a0: T, a1: number, a2: number, a3: number) => number
  [DefaultMinimap.dynCall_iiiiiiiifi]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number, a6: number, a7: number, a8: number, a9: number) => number
  [DefaultMinimap.dynCall_vijii]: (a0: T, a1: number, a2: bigint, a3: number, a4: number) => void
  [DefaultMinimap.dynCall_iiiijii]: (a0: T, a1: number, a2: number, a3: number, a4: bigint, a5: number, a6: number) => number
  [DefaultMinimap.dynCall_iiiiijiiiii]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: bigint, a6: number, a7: number, a8: number, a9: number, a10: number) => number
  [DefaultMinimap.dynCall_fdii]: (a0: T, a1: number, a2: number, a3: number) => number
  [DefaultMinimap.dynCall_viiiiiiiiijiiii]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number, a6: number, a7: number, a8: number, a9: number, a10: bigint, a11: number, a12: number, a13: number, a14: number) => void
  [DefaultMinimap.dynCall_id]: (a0: T, a1: number) => number
  [DefaultMinimap.dynCall_dd]: (a0: T, a1: number) => number
  [DefaultMinimap.dynCall_viij]: (a0: T, a1: number, a2: number, a3: bigint) => void
  [DefaultMinimap.dynCall_fdd]: (a0: T, a1: number, a2: number) => number
  [DefaultMinimap.dynCall_iiiij]: (a0: T, a1: number, a2: number, a3: number, a4: bigint) => number
  [DefaultMinimap.dynCall_iiiiijiiii]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: bigint, a6: number, a7: number, a8: number, a9: number) => number
  [DefaultMinimap.dynCall_iiijii]: (a0: T, a1: number, a2: number, a3: bigint, a4: number, a5: number) => number
  [DefaultMinimap.dynCall_iiiijiiii]: (a0: T, a1: number, a2: number, a3: number, a4: bigint, a5: number, a6: number, a7: number, a8: number) => number
  [DefaultMinimap.dynCall_iiiji]: (a0: T, a1: number, a2: number, a3: bigint, a4: number) => number
  [DefaultMinimap.dynCall_iidiiii]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number, a6: number) => number
  [DefaultMinimap.dynCall_iijii]: (a0: T, a1: number, a2: bigint, a3: number, a4: number) => number
  [DefaultMinimap.dynCall_iijj]: (a0: T, a1: number, a2: bigint, a3: bigint) => number
  [DefaultMinimap.dynCall_iijjjjjj]: (a0: T, a1: number, a2: bigint, a3: bigint, a4: bigint, a5: bigint, a6: bigint, a7: bigint) => number
  [DefaultMinimap.dynCall_viiiiiiiiiiiiiijiiiii]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number, a6: number, a7: number, a8: number, a9: number, a10: number, a11: number, a12: number, a13: number, a14: number, a15: bigint, a16: number, a17: number, a18: number, a19: number, a20: number) => void
  [DefaultMinimap.dynCall_viiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiijiiiiii]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number, a6: number, a7: number, a8: number, a9: number, a10: number, a11: number, a12: number, a13: number, a14: number, a15: number, a16: number, a17: number, a18: number, a19: number, a20: number, a21: number, a22: number, a23: number, a24: number, a25: number, a26: number, a27: number, a28: number, a29: number, a30: number, a31: number, a32: number, a33: bigint, a34: number, a35: number, a36: number, a37: number, a38: number, a39: number) => void
  [DefaultMinimap.dynCall_iiiiiiiiiiiiiiiii]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number, a6: number, a7: number, a8: number, a9: number, a10: number, a11: number, a12: number, a13: number, a14: number, a15: number, a16: number) => number
  [DefaultMinimap.dynCall_iiiiiiiiiiiiii]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number, a6: number, a7: number, a8: number, a9: number, a10: number, a11: number, a12: number, a13: number) => number
  [DefaultMinimap.dynCall_iiiiiiiiiiiii]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number, a6: number, a7: number, a8: number, a9: number, a10: number, a11: number, a12: number) => number
  [DefaultMinimap.dynCall_iiiiiiiiiiiiiiii]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number, a6: number, a7: number, a8: number, a9: number, a10: number, a11: number, a12: number, a13: number, a14: number, a15: number) => number
  [DefaultMinimap.dynCall_iiiiiiiiiii]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number, a6: number, a7: number, a8: number, a9: number, a10: number) => number
  [DefaultMinimap.dynCall_iiiiiiiiiiiiiii]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number, a6: number, a7: number, a8: number, a9: number, a10: number, a11: number, a12: number, a13: number, a14: number) => number
  [DefaultMinimap.dynCall_djijd]: (a0: T, a1: bigint, a2: number, a3: bigint, a4: number) => number
  [DefaultMinimap.dynCall_fdj]: (a0: T, a1: number, a2: bigint) => number
  [DefaultMinimap.dynCall_fdjj]: (a0: T, a1: number, a2: bigint, a3: bigint) => number
  [DefaultMinimap.dynCall_iddjj]: (a0: T, a1: number, a2: number, a3: bigint, a4: bigint) => number
  [DefaultMinimap.dynCall_idjj]: (a0: T, a1: number, a2: bigint, a3: bigint) => number
  [DefaultMinimap.dynCall_iidjjj]: (a0: T, a1: number, a2: number, a3: bigint, a4: bigint, a5: bigint) => number
  [DefaultMinimap.dynCall_iijjj]: (a0: T, a1: number, a2: bigint, a3: bigint, a4: bigint) => number
  [DefaultMinimap.dynCall_ij]: (a0: T, a1: bigint) => number
  [DefaultMinimap.dynCall_ijdj]: (a0: T, a1: bigint, a2: number, a3: bigint) => number
  [DefaultMinimap.dynCall_ijii]: (a0: T, a1: bigint, a2: number, a3: number) => number
  [DefaultMinimap.dynCall_ijiii]: (a0: T, a1: bigint, a2: number, a3: number, a4: number) => number
  [DefaultMinimap.dynCall_ijiiii]: (a0: T, a1: bigint, a2: number, a3: number, a4: number, a5: number) => number
  [DefaultMinimap.dynCall_ijiiiiiii]: (a0: T, a1: bigint, a2: number, a3: number, a4: number, a5: number, a6: number, a7: number, a8: number) => number
  [DefaultMinimap.dynCall_ijiiiiiiji]: (a0: T, a1: bigint, a2: number, a3: number, a4: number, a5: number, a6: number, a7: number, a8: bigint, a9: number) => number
  [DefaultMinimap.dynCall_ijiiiij]: (a0: T, a1: bigint, a2: number, a3: number, a4: number, a5: number, a6: bigint) => number
  [DefaultMinimap.dynCall_ijiiiijiii]: (a0: T, a1: bigint, a2: number, a3: number, a4: number, a5: number, a6: bigint, a7: number, a8: number, a9: number) => number
  [DefaultMinimap.dynCall_ijiiiijij]: (a0: T, a1: bigint, a2: number, a3: number, a4: number, a5: number, a6: bigint, a7: number, a8: bigint) => number
  [DefaultMinimap.dynCall_ijiiij]: (a0: T, a1: bigint, a2: number, a3: number, a4: number, a5: bigint) => number
  [DefaultMinimap.dynCall_ijiiijjiiiiii]: (a0: T, a1: bigint, a2: number, a3: number, a4: number, a5: bigint, a6: bigint, a7: number, a8: number, a9: number, a10: number, a11: number, a12: number) => number
  [DefaultMinimap.dynCall_ijiij]: (a0: T, a1: bigint, a2: number, a3: number, a4: bigint) => number
  [DefaultMinimap.dynCall_ijiiji]: (a0: T, a1: bigint, a2: number, a3: number, a4: bigint, a5: number) => number
  [DefaultMinimap.dynCall_ijiijj]: (a0: T, a1: bigint, a2: number, a3: number, a4: bigint, a5: bigint) => number
  [DefaultMinimap.dynCall_ijij]: (a0: T, a1: bigint, a2: number, a3: bigint) => number
  [DefaultMinimap.dynCall_ijiji]: (a0: T, a1: bigint, a2: number, a3: bigint, a4: number) => number
  [DefaultMinimap.dynCall_ijijijj]: (a0: T, a1: bigint, a2: number, a3: bigint, a4: number, a5: bigint, a6: bigint) => number
  [DefaultMinimap.dynCall_ijijj]: (a0: T, a1: bigint, a2: number, a3: bigint, a4: bigint) => number
  [DefaultMinimap.dynCall_ijijjj]: (a0: T, a1: bigint, a2: number, a3: bigint, a4: bigint, a5: bigint) => number
  [DefaultMinimap.dynCall_ijijjjj]: (a0: T, a1: bigint, a2: number, a3: bigint, a4: bigint, a5: bigint, a6: bigint) => number
  [DefaultMinimap.dynCall_ijj]: (a0: T, a1: bigint, a2: bigint) => number
  [DefaultMinimap.dynCall_ijji]: (a0: T, a1: bigint, a2: bigint, a3: number) => number
  [DefaultMinimap.dynCall_ijjii]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: number) => number
  [DefaultMinimap.dynCall_ijjiiiij]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: number, a5: number, a6: number, a7: bigint) => number
  [DefaultMinimap.dynCall_ijjiiiijjii]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: number, a5: number, a6: number, a7: bigint, a8: bigint, a9: number, a10: number) => number
  [DefaultMinimap.dynCall_ijjiiij]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: number, a5: number, a6: bigint) => number
  [DefaultMinimap.dynCall_ijjiiijjji]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: number, a5: number, a6: bigint, a7: bigint, a8: bigint, a9: number) => number
  [DefaultMinimap.dynCall_ijjiij]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: number, a5: bigint) => number
  [DefaultMinimap.dynCall_ijjiijiiii]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: number, a5: bigint, a6: number, a7: number, a8: number, a9: number) => number
  [DefaultMinimap.dynCall_ijjiijiiiii]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: number, a5: bigint, a6: number, a7: number, a8: number, a9: number, a10: number) => number
  [DefaultMinimap.dynCall_ijjiijiiiiji]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: number, a5: bigint, a6: number, a7: number, a8: number, a9: number, a10: bigint, a11: number) => number
  [DefaultMinimap.dynCall_ijjiijiiiijii]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: number, a5: bigint, a6: number, a7: number, a8: number, a9: number, a10: bigint, a11: number, a12: number) => number
  [DefaultMinimap.dynCall_ijjiijiiiijiij]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: number, a5: bigint, a6: number, a7: number, a8: number, a9: number, a10: bigint, a11: number, a12: number, a13: bigint) => number
  [DefaultMinimap.dynCall_ijjiijiiiijj]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: number, a5: bigint, a6: number, a7: number, a8: number, a9: number, a10: bigint, a11: bigint) => number
  [DefaultMinimap.dynCall_ijjiijjjjiiiiiiii]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: number, a5: bigint, a6: bigint, a7: bigint, a8: bigint, a9: number, a10: number, a11: number, a12: number, a13: number, a14: number, a15: number, a16: number) => number
  [DefaultMinimap.dynCall_ijjiijjjjjjjiiii]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: number, a5: bigint, a6: bigint, a7: bigint, a8: bigint, a9: bigint, a10: bigint, a11: bigint, a12: number, a13: number, a14: number, a15: number) => number
  [DefaultMinimap.dynCall_ijjij]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: bigint) => number
  [DefaultMinimap.dynCall_ijjiji]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: bigint, a5: number) => number
  [DefaultMinimap.dynCall_ijjijiii]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: bigint, a5: number, a6: number, a7: number) => number
  [DefaultMinimap.dynCall_ijjijj]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: bigint, a5: bigint) => number
  [DefaultMinimap.dynCall_ijjijjj]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: bigint, a5: bigint, a6: bigint) => number
  [DefaultMinimap.dynCall_ijjj]: (a0: T, a1: bigint, a2: bigint, a3: bigint) => number
  [DefaultMinimap.dynCall_ijjji]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: number) => number
  [DefaultMinimap.dynCall_ijjjii]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: number, a5: number) => number
  [DefaultMinimap.dynCall_ijjjiiiiiiii]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: number, a5: number, a6: number, a7: number, a8: number, a9: number, a10: number, a11: number) => number
  [DefaultMinimap.dynCall_ijjjiiiji]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: number, a5: number, a6: number, a7: bigint, a8: number) => number
  [DefaultMinimap.dynCall_ijjjiiijj]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: number, a5: number, a6: number, a7: bigint, a8: bigint) => number
  [DefaultMinimap.dynCall_ijjjij]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: number, a5: bigint) => number
  [DefaultMinimap.dynCall_ijjjijj]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: number, a5: bigint, a6: bigint) => number
  [DefaultMinimap.dynCall_ijjjijji]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: number, a5: bigint, a6: bigint, a7: number) => number
  [DefaultMinimap.dynCall_ijjjj]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint) => number
  [DefaultMinimap.dynCall_ijjjji]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint, a5: number) => number
  [DefaultMinimap.dynCall_ijjjjii]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint, a5: number, a6: number) => number
  [DefaultMinimap.dynCall_ijjjjj]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint, a5: bigint) => number
  [DefaultMinimap.dynCall_ijjjjji]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint, a5: bigint, a6: number) => number
  [DefaultMinimap.dynCall_ijjjjjij]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint, a5: bigint, a6: number, a7: bigint) => number
  [DefaultMinimap.dynCall_ijjjjjj]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint, a5: bigint, a6: bigint) => number
  [DefaultMinimap.dynCall_ijjjjjji]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint, a5: bigint, a6: bigint, a7: number) => number
  [DefaultMinimap.dynCall_ijjjjjjiij]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint, a5: bigint, a6: bigint, a7: number, a8: number, a9: bigint) => number
  [DefaultMinimap.dynCall_ijjjjjjijii]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint, a5: bigint, a6: bigint, a7: number, a8: bigint, a9: number, a10: number) => number
  [DefaultMinimap.dynCall_ijjjjjjj]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint, a5: bigint, a6: bigint, a7: bigint) => number
  [DefaultMinimap.dynCall_ijjjjjjjfj]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint, a5: bigint, a6: bigint, a7: bigint, a8: number, a9: bigint) => number
  [DefaultMinimap.dynCall_ijjjjjjjj]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint, a5: bigint, a6: bigint, a7: bigint, a8: bigint) => number
  [DefaultMinimap.dynCall_ijjjjjjjji]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint, a5: bigint, a6: bigint, a7: bigint, a8: bigint, a9: number) => number
  [DefaultMinimap.dynCall_ijjjjjjjjj]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint, a5: bigint, a6: bigint, a7: bigint, a8: bigint, a9: bigint) => number
  [DefaultMinimap.dynCall_ijjjjjjjjjj]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint, a5: bigint, a6: bigint, a7: bigint, a8: bigint, a9: bigint, a10: bigint) => number
  [DefaultMinimap.dynCall_ijjjjjjjjjjj]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint, a5: bigint, a6: bigint, a7: bigint, a8: bigint, a9: bigint, a10: bigint, a11: bigint) => number
  [DefaultMinimap.dynCall_ijjjjjjjjjjjjj]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint, a5: bigint, a6: bigint, a7: bigint, a8: bigint, a9: bigint, a10: bigint, a11: bigint, a12: bigint, a13: bigint) => number
  [DefaultMinimap.dynCall_ijjjjjjjjjjjjjj]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint, a5: bigint, a6: bigint, a7: bigint, a8: bigint, a9: bigint, a10: bigint, a11: bigint, a12: bigint, a13: bigint, a14: bigint) => number
  [DefaultMinimap.dynCall_jj]: (a0: T, a1: bigint) => bigint
  [DefaultMinimap.dynCall_jjii]: (a0: T, a1: bigint, a2: number, a3: number) => bigint
  [DefaultMinimap.dynCall_jjiii]: (a0: T, a1: bigint, a2: number, a3: number, a4: number) => bigint
  [DefaultMinimap.dynCall_jjiiiii]: (a0: T, a1: bigint, a2: number, a3: number, a4: number, a5: number, a6: number) => bigint
  [DefaultMinimap.dynCall_jjiijj]: (a0: T, a1: bigint, a2: number, a3: number, a4: bigint, a5: bigint) => bigint
  [DefaultMinimap.dynCall_jjij]: (a0: T, a1: bigint, a2: number, a3: bigint) => bigint
  [DefaultMinimap.dynCall_jjijjjji]: (a0: T, a1: bigint, a2: number, a3: bigint, a4: bigint, a5: bigint, a6: bigint, a7: number) => bigint
  [DefaultMinimap.dynCall_jjj]: (a0: T, a1: bigint, a2: bigint) => bigint
  [DefaultMinimap.dynCall_jjji]: (a0: T, a1: bigint, a2: bigint, a3: number) => bigint
  [DefaultMinimap.dynCall_jjjiii]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: number, a5: number) => bigint
  [DefaultMinimap.dynCall_jjjiijjj]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: number, a5: bigint, a6: bigint, a7: bigint) => bigint
  [DefaultMinimap.dynCall_jjjj]: (a0: T, a1: bigint, a2: bigint, a3: bigint) => bigint
  [DefaultMinimap.dynCall_jjjji]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: number) => bigint
  [DefaultMinimap.dynCall_jjjjiijii]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: number, a5: number, a6: bigint, a7: number, a8: number) => bigint
  [DefaultMinimap.dynCall_jjjjj]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint) => bigint
  [DefaultMinimap.dynCall_jjjjji]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint, a5: number) => bigint
  [DefaultMinimap.dynCall_jjjjjj]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint, a5: bigint) => bigint
  [DefaultMinimap.dynCall_viiiiiijji]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: number, a6: number, a7: bigint, a8: bigint, a9: number) => void
  [DefaultMinimap.dynCall_viiiijjjij]: (a0: T, a1: number, a2: number, a3: number, a4: number, a5: bigint, a6: bigint, a7: bigint, a8: number, a9: bigint) => void
  [DefaultMinimap.dynCall_viiijjji]: (a0: T, a1: number, a2: number, a3: number, a4: bigint, a5: bigint, a6: bigint, a7: number) => void
  [DefaultMinimap.dynCall_viijj]: (a0: T, a1: number, a2: number, a3: bigint, a4: bigint) => void
  [DefaultMinimap.dynCall_viijjiiiiiiijiijiiiii]: (a0: T, a1: number, a2: number, a3: bigint, a4: bigint, a5: number, a6: number, a7: number, a8: number, a9: number, a10: number, a11: number, a12: bigint, a13: number, a14: number, a15: bigint, a16: number, a17: number, a18: number, a19: number, a20: number) => void
  [DefaultMinimap.dynCall_vijjj]: (a0: T, a1: number, a2: bigint, a3: bigint, a4: bigint) => void
  [DefaultMinimap.dynCall_vijjji]: (a0: T, a1: number, a2: bigint, a3: bigint, a4: bigint, a5: number) => void
  [DefaultMinimap.dynCall_vijjjij]: (a0: T, a1: number, a2: bigint, a3: bigint, a4: bigint, a5: number, a6: bigint) => void
  [DefaultMinimap.dynCall_vj]: (a0: T, a1: bigint) => void
  [DefaultMinimap.dynCall_vji]: (a0: T, a1: bigint, a2: number) => void
  [DefaultMinimap.dynCall_vjii]: (a0: T, a1: bigint, a2: number, a3: number) => void
  [DefaultMinimap.dynCall_vjiiii]: (a0: T, a1: bigint, a2: number, a3: number, a4: number, a5: number) => void
  [DefaultMinimap.dynCall_vjiiiiiiiiiiijjiiijiiijijijjiiiiijiiiijj]: (a0: T, a1: bigint, a2: number, a3: number, a4: number, a5: number, a6: number, a7: number, a8: number, a9: number, a10: number, a11: number, a12: number, a13: bigint, a14: bigint, a15: number, a16: number, a17: number, a18: bigint, a19: number, a20: number, a21: number, a22: bigint, a23: number, a24: bigint, a25: number, a26: bigint, a27: bigint, a28: number, a29: number, a30: number, a31: number, a32: number, a33: bigint, a34: number, a35: number, a36: number, a37: number, a38: bigint, a39: bigint) => void
  [DefaultMinimap.dynCall_vjiiiiiiiijjjjj]: (a0: T, a1: bigint, a2: number, a3: number, a4: number, a5: number, a6: number, a7: number, a8: number, a9: number, a10: bigint, a11: bigint, a12: bigint, a13: bigint, a14: bigint) => void
  [DefaultMinimap.dynCall_vjiiiij]: (a0: T, a1: bigint, a2: number, a3: number, a4: number, a5: number, a6: bigint) => void
  [DefaultMinimap.dynCall_vjiij]: (a0: T, a1: bigint, a2: number, a3: number, a4: bigint) => void
  [DefaultMinimap.dynCall_vjiijiii]: (a0: T, a1: bigint, a2: number, a3: number, a4: bigint, a5: number, a6: number, a7: number) => void
  [DefaultMinimap.dynCall_vjiijj]: (a0: T, a1: bigint, a2: number, a3: number, a4: bigint, a5: bigint) => void
  [DefaultMinimap.dynCall_vjij]: (a0: T, a1: bigint, a2: number, a3: bigint) => void
  [DefaultMinimap.dynCall_vjijj]: (a0: T, a1: bigint, a2: number, a3: bigint, a4: bigint) => void
  [DefaultMinimap.dynCall_vjijjjj]: (a0: T, a1: bigint, a2: number, a3: bigint, a4: bigint, a5: bigint, a6: bigint) => void
  [DefaultMinimap.dynCall_vjj]: (a0: T, a1: bigint, a2: bigint) => void
  [DefaultMinimap.dynCall_vjji]: (a0: T, a1: bigint, a2: bigint, a3: number) => void
  [DefaultMinimap.dynCall_vjjii]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: number) => void
  [DefaultMinimap.dynCall_vjjiii]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: number, a5: number) => void
  [DefaultMinimap.dynCall_vjjiiiijj]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: number, a5: number, a6: number, a7: bigint, a8: bigint) => void
  [DefaultMinimap.dynCall_vjjiiij]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: number, a5: number, a6: bigint) => void
  [DefaultMinimap.dynCall_vjjiiijj]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: number, a5: number, a6: bigint, a7: bigint) => void
  [DefaultMinimap.dynCall_vjjij]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: bigint) => void
  [DefaultMinimap.dynCall_vjjiji]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: bigint, a5: number) => void
  [DefaultMinimap.dynCall_vjjijj]: (a0: T, a1: bigint, a2: bigint, a3: number, a4: bigint, a5: bigint) => void
  [DefaultMinimap.dynCall_vjjj]: (a0: T, a1: bigint, a2: bigint, a3: bigint) => void
  [DefaultMinimap.dynCall_vjjji]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: number) => void
  [DefaultMinimap.dynCall_vjjjii]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: number, a5: number) => void
  [DefaultMinimap.dynCall_vjjjiii]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: number, a5: number, a6: number) => void
  [DefaultMinimap.dynCall_vjjjijji]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: number, a5: bigint, a6: bigint, a7: number) => void
  [DefaultMinimap.dynCall_vjjjj]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint) => void
  [DefaultMinimap.dynCall_vjjjji]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint, a5: number) => void
  [DefaultMinimap.dynCall_vjjjjii]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint, a5: number, a6: number) => void
  [DefaultMinimap.dynCall_vjjjjiij]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint, a5: number, a6: number, a7: bigint) => void
  [DefaultMinimap.dynCall_vjjjjiijj]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint, a5: number, a6: number, a7: bigint, a8: bigint) => void
  [DefaultMinimap.dynCall_vjjjjij]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint, a5: number, a6: bigint) => void
  [DefaultMinimap.dynCall_vjjjjj]: (a0: T, a1: bigint, a2: bigint, a3: bigint, a4: bigint, a5: bigint) => void
}

export const InvokeMap = {
  [DefaultMinimap.invoke_ii]: DefaultMinimap.dynCall_ii,
  [DefaultMinimap.invoke_iii]: DefaultMinimap.dynCall_iii,
  [DefaultMinimap.invoke_iiii]: DefaultMinimap.dynCall_iiii,
  [DefaultMinimap.invoke_iiiii]: DefaultMinimap.dynCall_iiiii,
  [DefaultMinimap.invoke_iiiiii]: DefaultMinimap.dynCall_iiiiii,
  [DefaultMinimap.invoke_iiiiiii]: DefaultMinimap.dynCall_iiiiiii,
  [DefaultMinimap.invoke_iiiiiiii]: DefaultMinimap.dynCall_iiiiiiii,
  [DefaultMinimap.invoke_iiiiiiiii]: DefaultMinimap.dynCall_iiiiiiiii,
  [DefaultMinimap.invoke_iiiiiiiiii]: DefaultMinimap.dynCall_iiiiiiiiii,
  [DefaultMinimap.invoke_iiiiiiiiiiii]: DefaultMinimap.dynCall_iiiiiiiiiiii,
  [DefaultMinimap.invoke_v]: DefaultMinimap.dynCall_v,
  [DefaultMinimap.invoke_vi]: DefaultMinimap.dynCall_vi,
  [DefaultMinimap.invoke_vii]: DefaultMinimap.dynCall_vii,
  [DefaultMinimap.invoke_viii]: DefaultMinimap.dynCall_viii,
  [DefaultMinimap.invoke_viiii]: DefaultMinimap.dynCall_viiii,
  [DefaultMinimap.invoke_viiiii]: DefaultMinimap.dynCall_viiiii,
  [DefaultMinimap.invoke_viiiiii]: DefaultMinimap.dynCall_viiiiii,
  [DefaultMinimap.invoke_viiiiiii]: DefaultMinimap.dynCall_viiiiiii,
  [DefaultMinimap.invoke_viiiiiiii]: DefaultMinimap.dynCall_viiiiiiii,
  [DefaultMinimap.invoke_viiiiiiiii]: DefaultMinimap.dynCall_viiiiiiiii,
  [DefaultMinimap.invoke_iiji]: DefaultMinimap.dynCall_iiji,
  [DefaultMinimap.invoke_iji]: DefaultMinimap.dynCall_iji,
  [DefaultMinimap.invoke_jji]: DefaultMinimap.dynCall_jji,
  [DefaultMinimap.invoke_jiji]: DefaultMinimap.dynCall_jiji,
  [DefaultMinimap.invoke_iij]: DefaultMinimap.dynCall_iij,
  [DefaultMinimap.invoke_jii]: DefaultMinimap.dynCall_jii,
  [DefaultMinimap.invoke_ji]: DefaultMinimap.dynCall_ji,
  [DefaultMinimap.invoke_diiid]: DefaultMinimap.dynCall_diiid,
  [DefaultMinimap.invoke_iidi]: DefaultMinimap.dynCall_iidi,
  [DefaultMinimap.invoke_iddii]: DefaultMinimap.dynCall_iddii,
  [DefaultMinimap.invoke_iiiiiij]: DefaultMinimap.dynCall_iiiiiij,
  [DefaultMinimap.invoke_iiiiiiiiiijj]: DefaultMinimap.dynCall_iiiiiiiiiijj,
  [DefaultMinimap.invoke_iiiiiiiiiiji]: DefaultMinimap.dynCall_iiiiiiiiiiji,
  [DefaultMinimap.invoke_iiiiiiijjii]: DefaultMinimap.dynCall_iiiiiiijjii,
  [DefaultMinimap.invoke_iijiii]: DefaultMinimap.dynCall_iijiii,
  [DefaultMinimap.invoke_iiijiii]: DefaultMinimap.dynCall_iiijiii,
  [DefaultMinimap.invoke_iiiijj]: DefaultMinimap.dynCall_iiiijj,
  [DefaultMinimap.invoke_iidiii]: DefaultMinimap.dynCall_iidiii,
  [DefaultMinimap.invoke_fdi]: DefaultMinimap.dynCall_fdi,
  [DefaultMinimap.invoke_idii]: DefaultMinimap.dynCall_idii,
  [DefaultMinimap.invoke_iiiiiiiifi]: DefaultMinimap.dynCall_iiiiiiiifi,
  [DefaultMinimap.invoke_vijii]: DefaultMinimap.dynCall_vijii,
  [DefaultMinimap.invoke_iiiijii]: DefaultMinimap.dynCall_iiiijii,
  [DefaultMinimap.invoke_iiiiijiiiii]: DefaultMinimap.dynCall_iiiiijiiiii,
  [DefaultMinimap.invoke_fdii]: DefaultMinimap.dynCall_fdii,
  [DefaultMinimap.invoke_viiiiiiiiijiiii]: DefaultMinimap.dynCall_viiiiiiiiijiiii,
  [DefaultMinimap.invoke_id]: DefaultMinimap.dynCall_id,
  [DefaultMinimap.invoke_dd]: DefaultMinimap.dynCall_dd,
  [DefaultMinimap.invoke_viij]: DefaultMinimap.dynCall_viij,
  [DefaultMinimap.invoke_fdd]: DefaultMinimap.dynCall_fdd,
  [DefaultMinimap.invoke_iiiij]: DefaultMinimap.dynCall_iiiij,
  [DefaultMinimap.invoke_iiiiijiiii]: DefaultMinimap.dynCall_iiiiijiiii,
  [DefaultMinimap.invoke_iiijii]: DefaultMinimap.dynCall_iiijii,
  [DefaultMinimap.invoke_iiiijiiii]: DefaultMinimap.dynCall_iiiijiiii,
  [DefaultMinimap.invoke_iiiji]: DefaultMinimap.dynCall_iiiji,
  [DefaultMinimap.invoke_iidiiii]: DefaultMinimap.dynCall_iidiiii,
  [DefaultMinimap.invoke_iijii]: DefaultMinimap.dynCall_iijii,
  [DefaultMinimap.invoke_iijj]: DefaultMinimap.dynCall_iijj,
  [DefaultMinimap.invoke_iijjjjjj]: DefaultMinimap.dynCall_iijjjjjj,
  [DefaultMinimap.invoke_viiiiiiiiiiiiiijiiiii]: DefaultMinimap.dynCall_viiiiiiiiiiiiiijiiiii,
  [DefaultMinimap.invoke_viiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiijiiiiii]: DefaultMinimap.dynCall_viiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiijiiiiii,
  [DefaultMinimap.invoke_iiiiiiiiiiiiiiiii]: DefaultMinimap.dynCall_iiiiiiiiiiiiiiiii,
  [DefaultMinimap.invoke_iiiiiiiiiiiiii]: DefaultMinimap.dynCall_iiiiiiiiiiiiii,
  [DefaultMinimap.invoke_iiiiiiiiiiiii]: DefaultMinimap.dynCall_iiiiiiiiiiiii,
  [DefaultMinimap.invoke_iiiiiiiiiiiiiiii]: DefaultMinimap.dynCall_iiiiiiiiiiiiiiii,
  [DefaultMinimap.invoke_iiiiiiiiiii]: DefaultMinimap.dynCall_iiiiiiiiiii,
  [DefaultMinimap.invoke_iiiiiiiiiiiiiii]: DefaultMinimap.dynCall_iiiiiiiiiiiiiii,
  [DefaultMinimap.invoke_djijd]: DefaultMinimap.dynCall_djijd,
  [DefaultMinimap.invoke_fdj]: DefaultMinimap.dynCall_fdj,
  [DefaultMinimap.invoke_fdjj]: DefaultMinimap.dynCall_fdjj,
  [DefaultMinimap.invoke_iddjj]: DefaultMinimap.dynCall_iddjj,
  [DefaultMinimap.invoke_idjj]: DefaultMinimap.dynCall_idjj,
  [DefaultMinimap.invoke_iidjjj]: DefaultMinimap.dynCall_iidjjj,
  [DefaultMinimap.invoke_iijjj]: DefaultMinimap.dynCall_iijjj,
  [DefaultMinimap.invoke_ij]: DefaultMinimap.dynCall_ij,
  [DefaultMinimap.invoke_ijdj]: DefaultMinimap.dynCall_ijdj,
  [DefaultMinimap.invoke_ijii]: DefaultMinimap.dynCall_ijii,
  [DefaultMinimap.invoke_ijiii]: DefaultMinimap.dynCall_ijiii,
  [DefaultMinimap.invoke_ijiiii]: DefaultMinimap.dynCall_ijiiii,
  [DefaultMinimap.invoke_ijiiiiiii]: DefaultMinimap.dynCall_ijiiiiiii,
  [DefaultMinimap.invoke_ijiiiiiiji]: DefaultMinimap.dynCall_ijiiiiiiji,
  [DefaultMinimap.invoke_ijiiiij]: DefaultMinimap.dynCall_ijiiiij,
  [DefaultMinimap.invoke_ijiiiijiii]: DefaultMinimap.dynCall_ijiiiijiii,
  [DefaultMinimap.invoke_ijiiiijij]: DefaultMinimap.dynCall_ijiiiijij,
  [DefaultMinimap.invoke_ijiiij]: DefaultMinimap.dynCall_ijiiij,
  [DefaultMinimap.invoke_ijiiijjiiiiii]: DefaultMinimap.dynCall_ijiiijjiiiiii,
  [DefaultMinimap.invoke_ijiij]: DefaultMinimap.dynCall_ijiij,
  [DefaultMinimap.invoke_ijiiji]: DefaultMinimap.dynCall_ijiiji,
  [DefaultMinimap.invoke_ijiijj]: DefaultMinimap.dynCall_ijiijj,
  [DefaultMinimap.invoke_ijij]: DefaultMinimap.dynCall_ijij,
  [DefaultMinimap.invoke_ijiji]: DefaultMinimap.dynCall_ijiji,
  [DefaultMinimap.invoke_ijijijj]: DefaultMinimap.dynCall_ijijijj,
  [DefaultMinimap.invoke_ijijj]: DefaultMinimap.dynCall_ijijj,
  [DefaultMinimap.invoke_ijijjj]: DefaultMinimap.dynCall_ijijjj,
  [DefaultMinimap.invoke_ijijjjj]: DefaultMinimap.dynCall_ijijjjj,
  [DefaultMinimap.invoke_ijj]: DefaultMinimap.dynCall_ijj,
  [DefaultMinimap.invoke_ijji]: DefaultMinimap.dynCall_ijji,
  [DefaultMinimap.invoke_ijjii]: DefaultMinimap.dynCall_ijjii,
  [DefaultMinimap.invoke_ijjiiiij]: DefaultMinimap.dynCall_ijjiiiij,
  [DefaultMinimap.invoke_ijjiiiijjii]: DefaultMinimap.dynCall_ijjiiiijjii,
  [DefaultMinimap.invoke_ijjiiij]: DefaultMinimap.dynCall_ijjiiij,
  [DefaultMinimap.invoke_ijjiiijjji]: DefaultMinimap.dynCall_ijjiiijjji,
  [DefaultMinimap.invoke_ijjiij]: DefaultMinimap.dynCall_ijjiij,
  [DefaultMinimap.invoke_ijjiijiiii]: DefaultMinimap.dynCall_ijjiijiiii,
  [DefaultMinimap.invoke_ijjiijiiiii]: DefaultMinimap.dynCall_ijjiijiiiii,
  [DefaultMinimap.invoke_ijjiijiiiiji]: DefaultMinimap.dynCall_ijjiijiiiiji,
  [DefaultMinimap.invoke_ijjiijiiiijii]: DefaultMinimap.dynCall_ijjiijiiiijii,
  [DefaultMinimap.invoke_ijjiijiiiijiij]: DefaultMinimap.dynCall_ijjiijiiiijiij,
  [DefaultMinimap.invoke_ijjiijiiiijj]: DefaultMinimap.dynCall_ijjiijiiiijj,
  [DefaultMinimap.invoke_ijjiijjjjiiiiiiii]: DefaultMinimap.dynCall_ijjiijjjjiiiiiiii,
  [DefaultMinimap.invoke_ijjiijjjjjjjiiii]: DefaultMinimap.dynCall_ijjiijjjjjjjiiii,
  [DefaultMinimap.invoke_ijjij]: DefaultMinimap.dynCall_ijjij,
  [DefaultMinimap.invoke_ijjiji]: DefaultMinimap.dynCall_ijjiji,
  [DefaultMinimap.invoke_ijjijiii]: DefaultMinimap.dynCall_ijjijiii,
  [DefaultMinimap.invoke_ijjijj]: DefaultMinimap.dynCall_ijjijj,
  [DefaultMinimap.invoke_ijjijjj]: DefaultMinimap.dynCall_ijjijjj,
  [DefaultMinimap.invoke_ijjj]: DefaultMinimap.dynCall_ijjj,
  [DefaultMinimap.invoke_ijjji]: DefaultMinimap.dynCall_ijjji,
  [DefaultMinimap.invoke_ijjjii]: DefaultMinimap.dynCall_ijjjii,
  [DefaultMinimap.invoke_ijjjiiiiiiii]: DefaultMinimap.dynCall_ijjjiiiiiiii,
  [DefaultMinimap.invoke_ijjjiiiji]: DefaultMinimap.dynCall_ijjjiiiji,
  [DefaultMinimap.invoke_ijjjiiijj]: DefaultMinimap.dynCall_ijjjiiijj,
  [DefaultMinimap.invoke_ijjjij]: DefaultMinimap.dynCall_ijjjij,
  [DefaultMinimap.invoke_ijjjijj]: DefaultMinimap.dynCall_ijjjijj,
  [DefaultMinimap.invoke_ijjjijji]: DefaultMinimap.dynCall_ijjjijji,
  [DefaultMinimap.invoke_ijjjj]: DefaultMinimap.dynCall_ijjjj,
  [DefaultMinimap.invoke_ijjjji]: DefaultMinimap.dynCall_ijjjji,
  [DefaultMinimap.invoke_ijjjjii]: DefaultMinimap.dynCall_ijjjjii,
  [DefaultMinimap.invoke_ijjjjj]: DefaultMinimap.dynCall_ijjjjj,
  [DefaultMinimap.invoke_ijjjjji]: DefaultMinimap.dynCall_ijjjjji,
  [DefaultMinimap.invoke_ijjjjjij]: DefaultMinimap.dynCall_ijjjjjij,
  [DefaultMinimap.invoke_ijjjjjj]: DefaultMinimap.dynCall_ijjjjjj,
  [DefaultMinimap.invoke_ijjjjjji]: DefaultMinimap.dynCall_ijjjjjji,
  [DefaultMinimap.invoke_ijjjjjjiij]: DefaultMinimap.dynCall_ijjjjjjiij,
  [DefaultMinimap.invoke_ijjjjjjijii]: DefaultMinimap.dynCall_ijjjjjjijii,
  [DefaultMinimap.invoke_ijjjjjjj]: DefaultMinimap.dynCall_ijjjjjjj,
  [DefaultMinimap.invoke_ijjjjjjjfj]: DefaultMinimap.dynCall_ijjjjjjjfj,
  [DefaultMinimap.invoke_ijjjjjjjj]: DefaultMinimap.dynCall_ijjjjjjjj,
  [DefaultMinimap.invoke_ijjjjjjjji]: DefaultMinimap.dynCall_ijjjjjjjji,
  [DefaultMinimap.invoke_ijjjjjjjjj]: DefaultMinimap.dynCall_ijjjjjjjjj,
  [DefaultMinimap.invoke_ijjjjjjjjjj]: DefaultMinimap.dynCall_ijjjjjjjjjj,
  [DefaultMinimap.invoke_ijjjjjjjjjjj]: DefaultMinimap.dynCall_ijjjjjjjjjjj,
  [DefaultMinimap.invoke_ijjjjjjjjjjjjj]: DefaultMinimap.dynCall_ijjjjjjjjjjjjj,
  [DefaultMinimap.invoke_ijjjjjjjjjjjjjj]: DefaultMinimap.dynCall_ijjjjjjjjjjjjjj,
  [DefaultMinimap.invoke_jj]: DefaultMinimap.dynCall_jj,
  [DefaultMinimap.invoke_jjii]: DefaultMinimap.dynCall_jjii,
  [DefaultMinimap.invoke_jjiii]: DefaultMinimap.dynCall_jjiii,
  [DefaultMinimap.invoke_jjiiiii]: DefaultMinimap.dynCall_jjiiiii,
  [DefaultMinimap.invoke_jjiijj]: DefaultMinimap.dynCall_jjiijj,
  [DefaultMinimap.invoke_jjij]: DefaultMinimap.dynCall_jjij,
  [DefaultMinimap.invoke_jjijjjji]: DefaultMinimap.dynCall_jjijjjji,
  [DefaultMinimap.invoke_jjj]: DefaultMinimap.dynCall_jjj,
  [DefaultMinimap.invoke_jjji]: DefaultMinimap.dynCall_jjji,
  [DefaultMinimap.invoke_jjjiii]: DefaultMinimap.dynCall_jjjiii,
  [DefaultMinimap.invoke_jjjiijjj]: DefaultMinimap.dynCall_jjjiijjj,
  [DefaultMinimap.invoke_jjjj]: DefaultMinimap.dynCall_jjjj,
  [DefaultMinimap.invoke_jjjji]: DefaultMinimap.dynCall_jjjji,
  [DefaultMinimap.invoke_jjjjiijii]: DefaultMinimap.dynCall_jjjjiijii,
  [DefaultMinimap.invoke_jjjjj]: DefaultMinimap.dynCall_jjjjj,
  [DefaultMinimap.invoke_jjjjji]: DefaultMinimap.dynCall_jjjjji,
  [DefaultMinimap.invoke_jjjjjj]: DefaultMinimap.dynCall_jjjjjj,
  [DefaultMinimap.invoke_viiiiiijji]: DefaultMinimap.dynCall_viiiiiijji,
  [DefaultMinimap.invoke_viiiijjjij]: DefaultMinimap.dynCall_viiiijjjij,
  [DefaultMinimap.invoke_viiijjji]: DefaultMinimap.dynCall_viiijjji,
  [DefaultMinimap.invoke_viijj]: DefaultMinimap.dynCall_viijj,
  [DefaultMinimap.invoke_viijjiiiiiiijiijiiiii]: DefaultMinimap.dynCall_viijjiiiiiiijiijiiiii,
  [DefaultMinimap.invoke_vijjj]: DefaultMinimap.dynCall_vijjj,
  [DefaultMinimap.invoke_vijjji]: DefaultMinimap.dynCall_vijjji,
  [DefaultMinimap.invoke_vijjjij]: DefaultMinimap.dynCall_vijjjij,
  [DefaultMinimap.invoke_vj]: DefaultMinimap.dynCall_vj,
  [DefaultMinimap.invoke_vji]: DefaultMinimap.dynCall_vji,
  [DefaultMinimap.invoke_vjii]: DefaultMinimap.dynCall_vjii,
  [DefaultMinimap.invoke_vjiiii]: DefaultMinimap.dynCall_vjiiii,
  [DefaultMinimap.invoke_vjiiiiiiiiiiijjiiijiiijijijjiiiiijiiiijj]: DefaultMinimap.dynCall_vjiiiiiiiiiiijjiiijiiijijijjiiiiijiiiijj,
  [DefaultMinimap.invoke_vjiiiiiiiijjjjj]: DefaultMinimap.dynCall_vjiiiiiiiijjjjj,
  [DefaultMinimap.invoke_vjiiiij]: DefaultMinimap.dynCall_vjiiiij,
  [DefaultMinimap.invoke_vjiij]: DefaultMinimap.dynCall_vjiij,
  [DefaultMinimap.invoke_vjiijiii]: DefaultMinimap.dynCall_vjiijiii,
  [DefaultMinimap.invoke_vjiijj]: DefaultMinimap.dynCall_vjiijj,
  [DefaultMinimap.invoke_vjij]: DefaultMinimap.dynCall_vjij,
  [DefaultMinimap.invoke_vjijj]: DefaultMinimap.dynCall_vjijj,
  [DefaultMinimap.invoke_vjijjjj]: DefaultMinimap.dynCall_vjijjjj,
  [DefaultMinimap.invoke_vjj]: DefaultMinimap.dynCall_vjj,
  [DefaultMinimap.invoke_vjji]: DefaultMinimap.dynCall_vjji,
  [DefaultMinimap.invoke_vjjii]: DefaultMinimap.dynCall_vjjii,
  [DefaultMinimap.invoke_vjjiii]: DefaultMinimap.dynCall_vjjiii,
  [DefaultMinimap.invoke_vjjiiiijj]: DefaultMinimap.dynCall_vjjiiiijj,
  [DefaultMinimap.invoke_vjjiiij]: DefaultMinimap.dynCall_vjjiiij,
  [DefaultMinimap.invoke_vjjiiijj]: DefaultMinimap.dynCall_vjjiiijj,
  [DefaultMinimap.invoke_vjjij]: DefaultMinimap.dynCall_vjjij,
  [DefaultMinimap.invoke_vjjiji]: DefaultMinimap.dynCall_vjjiji,
  [DefaultMinimap.invoke_vjjijj]: DefaultMinimap.dynCall_vjjijj,
  [DefaultMinimap.invoke_vjjj]: DefaultMinimap.dynCall_vjjj,
  [DefaultMinimap.invoke_vjjji]: DefaultMinimap.dynCall_vjjji,
  [DefaultMinimap.invoke_vjjjii]: DefaultMinimap.dynCall_vjjjii,
  [DefaultMinimap.invoke_vjjjiii]: DefaultMinimap.dynCall_vjjjiii,
  [DefaultMinimap.invoke_vjjjijji]: DefaultMinimap.dynCall_vjjjijji,
  [DefaultMinimap.invoke_vjjjj]: DefaultMinimap.dynCall_vjjjj,
  [DefaultMinimap.invoke_vjjjji]: DefaultMinimap.dynCall_vjjjji,
  [DefaultMinimap.invoke_vjjjjii]: DefaultMinimap.dynCall_vjjjjii,
  [DefaultMinimap.invoke_vjjjjiij]: DefaultMinimap.dynCall_vjjjjiij,
  [DefaultMinimap.invoke_vjjjjiijj]: DefaultMinimap.dynCall_vjjjjiijj,
  [DefaultMinimap.invoke_vjjjjij]: DefaultMinimap.dynCall_vjjjjij,
  [DefaultMinimap.invoke_vjjjjj]: DefaultMinimap.dynCall_vjjjjj,
} as const
